import CloseIcon from "@mui/icons-material/Close";
import { Switch } from "@mui/material";
import dayjs from "dayjs";
import moment from "moment";
import { Component } from "react";
import ReactApexChart from "react-apexcharts";
import { connect } from "react-redux";
import { Link, Link as RouterLink } from "react-router-dom";
import { compose } from "recompose";
import { ConvertAmount } from "../../components/Comman/ConvertValueWithDenominator";
import { withRouter } from "../../components/withRouter";
import { cyanBlue } from "../../config/ColorObj";
import endpoint from "../../config/endpoints";
import * as myConstClass from "../../config/messageconstant";
import { getSalesTeamInfoByDatesWithAttendance } from "../../Slice/adminDashboard.slice";
import { getBeatFromSalesTeamId } from "../../Slice/beat.slice";
import { getDashboardClaimData } from "../../Slice/claim.slice";
import { getManagerDashboardApi } from "../../Slice/managerDashboard.slice";
import { apiGet } from "../../utils/api_service";
import DonutChart from "../DashbourdChanges/DonutChart";
import MonthlyBarChart from "../DashbourdChanges/MonthlyBarChart";
import NoDataFound from "../DashbourdChanges/NoDataFound";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { downloadF } from "../PDF/PDFDownload";
import GMapNew from "./GMapNew";
import { getLeaveAnalysisDataBySalesTeam } from "../../Slice/LeaveType.slice";
import {
  getTargetAnalysisData,
  getTargetAnalysisGraphData,
} from "../../Slice/regionAndTarget.slice";
import AssessmentIcon from "@mui/icons-material/Assessment";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import GroupIcon from "@mui/icons-material/Group";
class ManagerDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      insightFlag: false,
      alignment: "0",
      saleMonth: dayjs(),
      selectedDate: dayjs(),
      searchDashboardDate: dayjs(),
      dateForSalesTeamList: dayjs(),
      searchTerm: "",
      userWorkSummarySearchTerm: "",
      searchDate: dayjs(),
      customFromDate: dayjs(),
      customToDate: dayjs(),
      searchMonth: dayjs().format("YYYY-MM"),
      loginPersonDataList: [],
      categoryIdForSummary: "",
      claimAnalysisSearch: "",
      targetAnalysisSearch: "",
      leaveAnalysisSearch: "",
      DataToSetForCat: [],
      byProductWiseCatSummary: [],
      packagingTypeList: [],
      catWiseSummaryType: 0,
      showRow1Details: 4,
      activeTab: "0",
      activeDetail: "0",
      userSummaryList: [],
      showCustomDate: false,
      teamCoverageFirstList: [],
      userWorkSummaryList: [],
      timeSlotTaskList: [],
      searchValueForSalesTeamList: "",
      timeSlotDetailSearch: "",
      row1DetailSearch: "",
      checked: false,
      showTimeSlotDetail: false,
      totalOutletCount: 0,
      productiveCall: 0,
      remoteOrder: 0,
      unvisited: 0,
      zero: 0,
      totalAmount: 0,
      salesAmt: 0,
      otherTaskId: 0,
      otherTaskIdForTimeSlot: 0,
      tooltip: { visible: false, x: 0, y: 0, text: "" },
      grandTotal: 0,
      distributorsTotal: 0,
      beatTotal: 0,
      outletTotal: 0,
      tcTotal: 0,
      unvisitedTotal: 0,
      pcTotal: 0,
      totalAmtSum: 0,
      claimAnalysisData: [],
      targetAnalysisData: [],
      targetAnalysisChartData: [],
      leaveAnalysisData: [],
      claimFromDate: dayjs(),
      claimToDate: dayjs(),
      leaveFromDate: dayjs(),
      leaveToDate: dayjs(),
      targetFlag: 0,
      activeFlag: false,
      activeFilter: 0,
    };
    this.styles = {
      container: {
        backgroundColor: "#f8fafc",
        minHeight: "100vh",
        padding: "20px",
      },
      image: {
        maxWidth: "40px",
        height: "auto",
        borderRadius: "8px",
        display: "block",
      },
      lightBlueVariant1: {
        backgroundColor: "rgb(71 133 215)",
        padding: "15px",
        borderRadius: "15px",
        display: "inline-block",
        margin: "10px",
        width: "50%",
      },
      header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "18px",
      },
      title: {
        fontSize: "28px",
        fontWeight: "bold",
        color: "#2563eb",

        margin: "0",
      },
      headerRight: {
        display: "flex",
        alignItems: "center",
        gap: "15px",
      },
      calendarIcon: {
        width: "24px",
        height: "24px",
        backgroundColor: "#2563eb",
        borderRadius: "4px",
        display: "flex",
        alineItems: "center",
        justifyContent: "center",
        color: "white",
        fontSize: "14px",
      },
      dropdown: {
        padding: "8px 12px",
        border: "1px solid #d1d5db",
        borderRadius: "4px",
        backgroundColor: "white",
        marginRight: "20px",
      },
      currentDate: {
        color: "#9ca3af",
        fontSize: "14px",
      },
      mainContent: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr",
        gap: "10px",
        display: "flex",
        justifyContent: "flex-between",
        width: "100%",
      },
      sectionForProgessMTD: {
        backgroundColor: "white",
        borderRadius: "8px",
        padding: "24px",
        width: "25%",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        marginTop: "1%",
      },
      sectionForUserWorkSummary: {
        backgroundColor: "white",
        borderRadius: "8px",
        padding: "24px",
        width: "51%",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        marginTop: "1%",
      },
      sectionForTimeslot: {
        backgroundColor: "white",
        borderRadius: "8px",
        padding: "24px",
        width: "50%",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        marginTop: "1%",
      },
      sectionForSalesTeam: {
        backgroundColor: "white",
        borderRadius: "8px",
        padding: "24px",
        width: "100%",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        marginTop: "1%",
      },
      sectionForProgessTodays: {
        backgroundColor: "white",
        borderRadius: "8px",
        padding: "24px",
        width: "24%",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        marginTop: "1%",
      },
      sectionForUserSummary: {
        backgroundColor: "white",
        borderRadius: "8px",
        padding: "24px",
        width: "25%",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        height: "420px",
      },
      sectionForDetails: {
        backgroundColor: "white",
        borderRadius: "8px",
        width: "25%",
        padding: "24px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
      },
      sectionTitle: {
        fontSize: "18px",
        fontWeight: "600",
        color: "#374151",
      },
      fieldGroup: {
        marginBottom: "16px",
      },
      label: {
        display: "block",
        fontSize: "18px",
        color: "#6b7280",
        marginTop: "-13px",
      },
      inputField: {
        backgroundColor: "#f3f4f6",
        padding: "8px 12px",
        borderRadius: "7px",
        color: "#374151",
        fontWeight: "500",
        width: "80%",
        boxSizing: "border-box",
      },
      inputFieldForName: {
        backgroundColor: "#f3f4f6",
        padding: "8px 12px",
        borderRadius: "7px",
        color: "#374151",
        fontWeight: "500",
        width: "100%",
        boxSizing: "border-box",
      },
      row: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        marginBottom: "16px",
      },
      rowThree: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr",
        gap: "12px",
      },
      badge: {
        display: "inline-block",
        padding: "6px 14px",
        borderRadius: "16px",
        fontSize: "12px",
        fontWeight: "500",
        color: "white",
      },
      blueBadge: {
        backgroundColor: "#3b82f6",
      },
      greenBadge: {
        backgroundColor: "#22c55e",
      },
      textValue: {
        color: "#374151",
        fontWeight: "500",
        fontSize: "14px",
      },
      contactValue: {
        color: "#374151",
        fontWeight: "600",
        fontSize: "16px",
        marginTop: "17px",
      },
      metricsGrid: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        textAlign: "center",
      },
      metricItem: {
        marginBottom: "25px",
      },
      metricLabel: {
        fontSize: "18px",
        color: "#6b7280",
        marginBottom: "6px",
      },
      metricValue: {
        fontSize: "18px",
        fontWeight: "600",
        color: "#374151",
        textAlign: "center",
      },
      progressSection: {
        display: "flex",
        flexDirection: "column",
        gap: "30px",
      },
      progressRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      },
      circularProgress: {
        position: "relative",
        width: "80px",
        height: "80px",
      },
      progressText: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        fontSize: "16px",
        fontWeight: "600",
        color: "#374151",
      },
      progressLabelBottom: {
        fontSize: "16px",
        color: "#6b7280",
        marginBottom: "8px",
        marginLeft: "35px",
        textAlign: "center",
      },
      progressLabel: {
        fontSize: "16px",
        color: "#6b7280",
        marginBottom: "8px",
        textAlign: "center",
      },
      progressValue: {
        fontSize: "16px",
        fontWeight: "600",
        color: "#374151",
        textAlign: "center",
      },
      progressValueBottom: {
        fontSize: "16px",
        fontWeight: "600",
        color: "#374151",
        marginLeft: "30px",
        textAlign: "center",
      },
      varianceItem: {
        textAlign: "center",
      },
    };

    this.stylesForProgressBar = {
      sectionForDetails: {
        backgroundColor: "white",
        borderRadius: "8px",
        padding: "24px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        maxWidth: "500px",
        margin: "20px auto",
      },
      sectionTitle: {
        fontSize: "18px",
        fontWeight: "600",
        color: "#374151",
        marginBottom: "20px",
      },
      fieldGroup: {
        marginBottom: "16px",
      },
      label: {
        display: "block",
        fontSize: "13px",
        color: "#6b7280",
        marginBottom: "6px",
      },
      inputFieldForName: {
        backgroundColor: "#f3f4f6",
        padding: "8px 12px",
        borderRadius: "7px",
        color: "#374151",
        fontWeight: "500",
        width: "100%",
        boxSizing: "border-box",
      },
      inputField: {
        backgroundColor: "#f3f4f6",
        padding: "10px 12px",
        borderRadius: "4px",
        color: "#374151",
        fontWeight: "500",
        width: "100%",
        boxSizing: "border-box",
      },
      row: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "16px",
        marginBottom: "16px",
      },
      progressContainer: {
        backgroundColor: "#f3f4f6",
        padding: "12px",
        borderRadius: "7px",
        width: "100%",
        boxSizing: "border-box",
      },
      progressHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "8px",
      },
      progressLabel: {
        fontSize: "12px",
        color: "#6b7280",
        fontWeight: "500",
      },
      progressValue: {
        fontSize: "12px",
        color: "#374151",
        fontWeight: "600",
      },
      mainAmount: {
        fontSize: "16px",
        fontWeight: "600",
        color: "#374151",
        marginBottom: "10px",
      },
      progressBarContainer: {
        width: "100%",
        backgroundColor: "#e5e7eb",
        borderRadius: "10px",
        overflow: "hidden",
        height: "8px",
        marginBottom: "8px",
      },
      progressBarFill: {
        height: "100%",
        backgroundColor: "#3b82f6",
        borderRadius: "10px",
        transition: "width 0.3s ease",
      },
      percentageText: {
        textAlign: "center",
        fontSize: "11px",
        color: "#6b7280",
        fontWeight: "500",
      },
    };

    this.stylesForTgtAndAchievement = {
      card: {
        backgroundColor: "#fff",
        borderRadius: "10px",
        padding: "16px",
        maxWidth: "400px",
        boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
      },
      headerRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      },
      title: {
        fontWeight: "bold",
        fontSize: "16px",
        color: "#000",
      },
      badge: {
        backgroundColor: "#E5F1F9",
        color: "#1C4E80",
        fontSize: "12px",
        padding: "5px 9px",
        borderRadius: "6px",
        fontWeight: "500",
      },
      dataRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        margin: "10px 0 6px",
      },
      achievedAmount: {
        color: "green",
        fontSize: "16px",
        fontWeight: "500",
      },
      targetLabel: {
        color: "#004969",
        fontSize: "13px",
        fontWeight: "bold",
      },
      targetAmount: {
        color: "red",
        fontSize: "16px",
        fontWeight: "500",
      },
      progressBar: {
        height: "6px",
        backgroundColor: "rgb(217, 217, 225)",
        borderRadius: "3px",
        overflow: "hidden",
      },
      progressFill: {
        height: "100%",
        backgroundColor: "green",
        width: `34%`,
        transition: "width 0.3s ease-in-out",
      },
    };

    this.tableStyles = {
      tabContainer: {
        display: "flex",
        marginBottom: "16px",
        borderBottom: "1px solid #E5F1F9",
      },
      tableWrapper: {
        maxHeight: "400px", // Adjust as needed for your layout
        overflowY: "auto",
        width: "100%",
        display: "block", // Ensures proper scroll behavior
      },
      table: {
        width: "100%",
        borderCollapse: "collapse",
        display: "table", // Ensures table behaves correctly
      },
      stickyHeader: {
        position: "sticky",
        top: 0,
        backgroundColor: "#1C4E80", // Matches headerRow background
        zIndex: 10, // Ensures header stays above body
      },
      tab: {
        padding: "8px 16px",
        cursor: "pointer",
        color: "#333",
        fontSize: "14px",
        fontWeight: "500",
        transition: "color 0.2s ease-in-out",
      },
      activeTab: {
        color: "#1C4E80",
        borderBottom: "2px solid #1C4E80",
      },
      activeCard: {
        color: "#0B153B",
        borderBottom: "3px solid #B3C96A",
        fontWeight: "bold",
      },
      activeFilter: {
        fontSize: "14px",
        backgroundColor: "#DFF6FF",
        borderRadius: "8px",
        padding: "8px 16px",
        fontWeight: "bolder",
        color: "#006B8F",
        height: "40px",
        width: "auto",
        cursor: "pointer",
      },
      inActiveFilter: {
        fontSize: "14px",
        padding: "8px 16px",
        fontWeight: 400,
        color: "#006B8F",
        height: "40px",
        width: "auto",
        cursor: "pointer",
      },
      noData: {
        padding: "16px",
        textAlign: "center",
        fontSize: "14px",
        color: "#666",
      },
      tableContainer: {
        backgroundColor: "#fff",
        borderRadius: "10px",
        padding: "16px",
        maxWidth: "1000px",
        margin: "0 auto",
        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
      },
      searchContainer: {
        marginBottom: "16px",
        display: "flex",
        alignItems: "center",
        maxWidth: "300px",
      },
      headerRow: {
        backgroundColor: "#F9FBFC",
        color: "#000",
        fontWeight: "bold",
        fontSize: "14px",
      },
      headerCell: {
        padding: "12px 16px",
        textAlign: "center",
        borderBottom: "2px solid #E5F1F9",
        fontWeight: 600,
      },
      dataRow: {
        backgroundColor: "#fff",
        transition: "background-color 0.2s ease-in-out",
      },
      dataRowHover: {
        backgroundColor: "#E5F1F9",
      },
      dataCell: {
        padding: "12px 16px",
        fontSize: "13px",
        color: "#333",
        borderBottom: "1px solid #E5F1F9",
      },
      amountCell: {
        color: "#004969",
        fontWeight: "500",
        fontSize: "13px",
      },
      alternateRow: {
        backgroundColor: "#fff",
      },
      activeRow: {
        backgroundColor: "#DBF9D9",
      },
      searchInput: {
        width: "100%",
        padding: "8px 12px",
        fontSize: "14px",
        border: "1px solid #E5F1F9",
        borderRadius: "6px",
        outline: "none",
        color: "#333",
        transition: "border-color 0.3s ease-in-out",
      },
      searchInputFocus: {
        borderColor: "#1C4E80",
        boxShadow: "0 0 5px rgba(28, 78, 128, 0.3)",
      },
      statusPending: {
        backgroundColor: "#FEF5D6",
        color: "#9A822E",
        borderRadius: 50,
        textAlign: "center",
        fontWeight: "500",
        padding: "5px 10px",
      },
      statusCancelled: {
        backgroundColor: "#D0D4DC",
        color: "#383F4B",
        borderRadius: 50,
        textAlign: "center",
        fontWeight: "500",
        padding: "5px 10px",
      },
      statusApproved: {
        backgroundColor: "#DBF9D9",
        color: "#619753",
        borderRadius: 50,
        textAlign: "center",
        fontWeight: "500",
        padding: "5px 10px",
      },
      statusRejected: {
        backgroundColor: "#FAD5D6",
        color: "#AE192D",
        borderRadius: 50,
        textAlign: "center",
        fontWeight: "500",
        padding: "5px 10px",
      },
    };

    this.achieved = 1298776;
    this.target = 3400000;
    this.percentage = Math.round((this.achieved / this.target) * 100);
  }

  handleChange = (event, newAlignment) => {
    if (newAlignment !== null) {
      this.setState({ alignment: newAlignment });
    }
  };

  formatNumber = (num) => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(2) + "M";
    } else if (num >= 1000) {
      return (num / 1000).toFixed(0) + "k";
    }
    return num.toString();
  };

  CircularProgress = ({ percentage, color, size = 140 }) => {
    const radius = (size - 8) / 2;
    const circumference = 2 * Math.PI * radius;
    const strokeDasharray = circumference;
    const strokeDashoffset = circumference - (percentage / 100) * circumference;

    return (
      <div
        style={{ ...this.styles.circularProgress, width: size, height: size }}
      >
        <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke="#e5e7eb"
            strokeWidth="6"
            fill="none"
          />
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke={color}
            strokeWidth="6"
            fill="none"
            strokeDasharray={strokeDasharray}
            strokeDashoffset={strokeDashoffset}
            strokeLinecap="round"
          />
        </svg>
        <div style={this.styles.progressText}>
          {percentage === parseInt(percentage)
            ? percentage
            : percentage?.toFixed(1)}
          {typeof percentage === "number" && percentage <= 100 ? "%" : ""}
        </div>
      </div>
    );
  };

  getDashboardData = async (searchDashboardDate) => {
    const { showLoador, showNotification, getManagerDashboardApi } = this.props;
    const { selectedDate } = this.state;
    if (navigator.onLine) {
      let loginPersonDataList = [];
      let loginPersonName = "";
      let achievedAmount = "";
      let ruAchievedQty = "";
      let loginUserId = localStorage.getItem("userId")
        ? localStorage.getItem("userId")
        : "";

      if (localStorage.getItem("loginUserData")) {
        let loginUserDataObj = JSON.parse(
          localStorage.getItem("loginUserData")
        );

        loginPersonName =
          loginUserDataObj.name !== null &&
          loginUserDataObj.stockStakeHolderType !== null &&
          loginUserDataObj.stockStakeHolderType.prefix !== null
            ? loginUserDataObj.name +
              " (" +
              loginUserDataObj.stockStakeHolderType.prefix +
              ")"
            : "";
      }

      showLoador({ loador: true });
      await getManagerDashboardApi({
        date: searchDashboardDate,
      }).then(({ response, success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({
            msg: myConstClass.serverMsg,
            severity: "error",
          });
        } else {
          if (response) {
            (ruAchievedQty =
              response?.dtoSalesPersonYearMonthTargetAndActualAmt
                ?.ruAchievedQty),
              (achievedAmount = ConvertAmount({
                amount:
                  response?.dtoSalesPersonYearMonthTargetAndActualAmt
                    ?.actualAmt,
              }));
          }
        }
      });

      loginPersonDataList.push({
        index: 1,
        loginPersonId: loginUserId,
        loginPersonName: loginPersonName,
        achievedAmount: achievedAmount + " / " + ruAchievedQty,
      });

      this.setState({
        loginPersonDataList,
        showRow1Details: 4,
        totalOutletCount: 0,
        zero: 0,
        productiveCall: 0,
        unvisited: 0,
        salesAmt: 0,
        totalAmount: 0,
        remoteOrder: 0,
      });
    } else {
      showNotification({ msg: myConstClass.noInternetMsg, severity: "error" });
    }
  };

  getTargetAchievementData = async (rowData) => {
    const { showLoador, showNotification, getTargetAnalysisData } = this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      await getTargetAnalysisData({
        flag: rowData ? rowData.flag : 0,
        fromDate: rowData ? rowData.fromDate : "",
        toDate: rowData ? rowData.toDate : "",
        monthYear: rowData ? rowData.monthYear : "",
      }).then(({ response, success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({
            msg: myConstClass.serverMsg,
            severity: "error",
          });
        } else {
          this.setState({
            targetAnalysisData: response ?? [],
          });
        }
      });
    } else {
      showNotification({ msg: myConstClass.noInternetMsg, severity: "error" });
    }
  };

  getClaimData = async (rowData) => {
    const { showLoador, showNotification, getDashboardClaimData } = this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      await getDashboardClaimData({
        salesTeamId: "",
        flag: rowData ? rowData.flag : 0,
        fromDate: rowData ? rowData.fromDate : "",
        toDate: rowData ? rowData.toDate : "",
      }).then(({ response, success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({
            msg: myConstClass.serverMsg,
            severity: "error",
          });
        } else {
          this.setState({
            claimAnalysisData: response ?? [],
          });
        }
      });
    } else {
      showNotification({ msg: myConstClass.noInternetMsg, severity: "error" });
    }
  };

  getLeaveData = async (rowData) => {
    const { showLoador, showNotification, getLeaveAnalysisDataBySalesTeam } =
      this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      await getLeaveAnalysisDataBySalesTeam({
        salesTeamId: "",
        flag: rowData ? rowData.flag : 0,
        fromDate: rowData ? rowData.fromDate : "",
        toDate: rowData ? rowData.toDate : "",
      }).then(({ response, success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({
            msg: myConstClass.serverMsg,
            severity: "error",
          });
        } else {
          this.setState({
            leaveAnalysisData: response ?? [],
          });
        }
      });
    } else {
      showNotification({ msg: myConstClass.noInternetMsg, severity: "error" });
    }
  };

  onChangeDashboardDate = (e) => {
    this.setState({ searchDashboardDate: e.target.value });
    console.debug(e.target.value);
    const [year, month, day] = e.target.value.split("-");
    const formattedDate = `${day}-${month}-${year}`;
    this.getDashboardData(formattedDate);
  };

  async componentDidMount() {
    this.getDashboardData(this.state.searchDashboardDate.format("DD-MM-YYYY"));
  }

  onClickSalesTeamName = (row) => {
    console.log(row);
  };

  showTooltip = (event, text) => {
    const rect = event.target.getBoundingClientRect();
    this.setState({
      tooltip: {
        visible: true,
        x: rect.left + window.scrollX + rect.width,
        y: rect.top + window.scrollY + 10,
        text,
      },
    });
  };

  hideTooltip = () => {
    this.setState({ tooltip: { visible: false, x: 0, y: 0, text: "" } });
  };

  hideTooltipWithDelay = () => {
    this.tooltipTimeout = setTimeout(() => {
      this.hideTooltip();
    }, 100); // 200ms delay
  };

  changeRadioHandler = (event) => {
    this.setState({
      catWiseSummaryType: event.target.value,
    });
  };

  onClickCatgoryWiseSummary = (categoryId) => {
    const { showLoador, showNotification } = this.props;
    const { catWiseSummaryType, searchDashboardDate, checked } = this.state;

    if (catWiseSummaryType == 0 && !checked) {
      let byProductWiseCatSummary = [];
      showLoador({ loador: true });
      apiGet({
        url:
          endpoint.outletOrderHeader +
          "/product-wise-total-amt-by-category-and-date?date=" +
          dayjs(searchDashboardDate).format("DD-MM-YYYY") +
          "&categoryId=" +
          categoryId,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          if (data && data.data) {
            const grandTotal = data.data.dtoGroupWiseTotalAmtAndQty.reduce(
              (sum, dataObj) => sum + Number(dataObj.totalAmt),
              0
            );
            const grandTotalForProductWise = ConvertAmount({
                amount: grandTotal,
              }),
              byProductWiseCatSummary =
                data.data.dtoGroupWiseTotalAmtAndQty.map((dataObj, index) => {
                  return {
                    index: index + 1,
                    id: dataObj.id,
                    name: dataObj.name,
                    totalQty: dataObj.totalQty,
                    totalAmt: ConvertAmount({ amount: dataObj.totalAmt }),
                  };
                });

            this.setState({
              categoryIdForSummary: categoryId,
              DataToSetForCat: [
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Category",
                  value:
                    data.data.category !== null &&
                    data.data.category.name !== null
                      ? data.data.category.name
                      : "-",
                },
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Total Amt",
                  value: grandTotalForProductWise
                    ? grandTotalForProductWise
                    : "",
                },
              ],
              byProductWiseCatSummary,
              onClickCatSummaryFlag: true,
            });
          }
        } else {
          showNotification({ msg: myConstClass.serverMsg, severity: "error" });
        }
      });
    } else {
      showLoador({ loador: true });
      apiGet({
        url:
          endpoint.outletOrderHeader +
          "/packing-type-wise-total-amt-by-category-and-date?date=" +
          dayjs(searchDashboardDate).format("DD-MM-YYYY") +
          "&categoryId=" +
          categoryId,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          if (data && data.data) {
            const grandTotal = data.data.dtoPackagingTypeWiseTotalList.reduce(
              (sum, dataObj) => sum + Number(dataObj.totalAmt),
              0
            );
            const grandTotalForPackagingTypeWise = ConvertAmount({
                amount: grandTotal,
              }),
              packagingTypeList = data.data.dtoPackagingTypeWiseTotalList.map(
                (dataObj, index) => {
                  return {
                    index: index + 1,
                    id: dataObj.id !== null ? dataObj.id : "",
                    name:
                      dataObj.packagingType !== null
                        ? dataObj.packagingType.name
                        : "",
                    totalQty: dataObj.totalQty !== null ? dataObj.totalQty : "",
                    totalAmt: ConvertAmount({ amount: dataObj.totalAmt }),
                  };
                }
              );

            this.setState({
              categoryIdForSummary: categoryId,
              DataToSetForCat: [
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Category",
                  value:
                    data.data.category !== null &&
                    data.data.category.name !== null
                      ? data.data.category.name
                      : "-",
                },
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Total Amt",
                  value: grandTotalForPackagingTypeWise
                    ? grandTotalForPackagingTypeWise
                    : "",
                },
              ],
              packagingTypeList,
              onClickCatSummaryFlag: true,
            });
          }
        } else {
          showNotification({ msg: myConstClass.serverMsg, severity: "error" });
        }
      });
    }
  };

  searchSalesTeamData = () => {
    const {
      getSalesTeamInfoByDatesWithAttendance,
      showLoador,
      showNotification,
      myConstClass,
    } = this.props;
    const { searchDate } = this.state;
    console.log(searchDate + " " + dayjs(searchDate).format("DD-MM-YYYY"));
    if (navigator.onLine) {
      showLoador({ loador: true });
      getSalesTeamInfoByDatesWithAttendance({
        fromDate: dayjs(searchDate).format("DD-MM-YYYY"),
        toDate: dayjs(searchDate).format("DD-MM-YYYY"),
      }).then(({ response, success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: response.serverMsg, severity: "error" });
        } else {
          let totalOutletCount = 0,
            zero = 0,
            productiveCall = 0,
            unvisited = 0,
            salesAmt = 0,
            totalAmount = 0,
            remoteOrder = 0;
          if (response.length !== 0) {
            response.map((salesTeam) => {
              totalOutletCount = totalOutletCount + +salesTeam.totalOutletCount;
              productiveCall = productiveCall + +salesTeam.productiveCall;
              zero = zero + +salesTeam.zeroOrderCount;
              unvisited = unvisited + +salesTeam.unvisitedOutletCount;
              salesAmt = salesAmt + +salesTeam.totalSalesAmt;
              totalAmount = totalAmount + +salesTeam.totalAmount;
              remoteOrder = remoteOrder + +salesTeam.remoteOrderCount;
            });
          }
          this.setState({
            totalOutletCount: totalOutletCount,
            zero: zero,
            productiveCall: productiveCall,
            unvisited: unvisited,
            salesAmt: salesAmt,
            totalAmount: totalAmount,
            remoteOrder: remoteOrder,
          });
        }
      });
    } else {
      showNotification({ msg: myConstClass.noInternetMsg, severity: "error" });
    }
  };

  userSummaryCardMethod = () => {
    const { showLoador, showNotification } = this.props;
    const { searchDashboardDate } = this.state;

    let userSummaryList = [];
    showLoador({ loador: true });
    apiGet({
      url:
        endpoint.salesExecutive +
        "/get-sales-team-with-flag-check-in-out-status?date=" +
        dayjs(searchDashboardDate).format("DD-MM-YYYY"),
    }).then(({ data, success }) => {
      showLoador({ loador: false });
      if (success) {
        if (data && data.data) {
          userSummaryList = data.data.map((dataObj, index) => {
            return {
              index: index + 1,
              id: dataObj.id !== null ? dataObj.id : "",
              name:
                dataObj.name !== null && dataObj.stockHolderShortName !== null
                  ? dataObj.name + " (" + dataObj.stockHolderShortName + ")"
                  : "",
              address: dataObj.address !== null ? dataObj.address : "",
              flag:
                dataObj.flag !== null
                  ? dataObj.flag == 0
                    ? "Absent"
                    : dataObj.flag == 1
                    ? "Late"
                    : dataObj.flag == 2
                    ? "In Time"
                    : "On Leave"
                  : "",
              checkInTime:
                dataObj.checkInTime !== null ? dataObj.checkInTime : "",
              checkOutTime:
                dataObj.checkOutTime !== null ? dataObj.checkOutTime : "",
              otherTaskName:
                dataObj.otherTaskName !== null ? dataObj.otherTaskName : "-",
              workingHrs: dataObj.workingHrs !== null ? dataObj.workingHrs : "",
              userTypeId: dataObj.userTypeId !== null ? dataObj.userTypeId : "",
            };
          });

          this.setState({ userSummaryList, showRow1Details: 1 });
        }
      } else {
        showNotification({ msg: myConstClass.serverMsg, severity: "error" });
      }
    });
  };

  rowLinkForTeamCoverage = (rowData) => {
    const { showLoador, showNotification } = this.props;
    const { searchDashboardDate } = this.state;
    // http://localhost:8088/api/distributiondevelop/v1/manager-logs/get-team-or-area-wise-sales-team-and-counts?date=14-08-2025&flag=0&salesTeamId=74a1cf19-4fad-476d-8611-65e59aa1a8de
    let teamCoverageFirstList = [];
    showLoador({ loador: true });
    apiGet({
      url:
        endpoint.managerLogs +
        "/get-team-or-area-wise-sales-team-and-counts?date=" +
        dayjs(searchDashboardDate).format("DD-MM-YYYY") +
        "&flag=1&salesTeamId=",
    }).then(({ data, success }) => {
      showLoador({ loador: false });
      if (success) {
        if (data && data.data) {
          teamCoverageFirstList = data.data.map((dataObj, index) => {
            return {
              index: index + 1,
              salesTeamId:
                dataObj.salesTeam !== null ? dataObj.salesTeam.id : "",
              salesTeamName:
                dataObj.salesTeam !== null &&
                dataObj.salesTeam.stockStakeHolderType !== null
                  ? dataObj.salesTeam.name +
                    " (" +
                    dataObj.salesTeam.stockStakeHolderType.prefix +
                    ")"
                  : "",
              salesTeamUserTypeId:
                dataObj.salesTeam !== null &&
                dataObj.salesTeam.stockStakeHolderType !== null &&
                dataObj.salesTeam.stockStakeHolderType.userType !== null
                  ? dataObj.salesTeam.stockStakeHolderType.userType.id
                  : "",
              address:
                dataObj.salesTeam !== null ? dataObj.salesTeam.address : "",
              distributorsCount:
                dataObj.distributorsCount !== null
                  ? dataObj.distributorsCount
                  : "",
              beatCount: dataObj.beatCount !== null ? dataObj.beatCount : "",
              outletCount:
                dataObj.outletCount !== null ? dataObj.outletCount : "",
              // totalAmt:
              //   dataObj.totalAmt !== null
              //     ? ConvertAmount({ amount: dataObj.totalAmt })
              //     : "",
              totalAmt: dataObj.totalAmt !== null ? dataObj.totalAmt : "",
              tcCount: dataObj.tcCount !== null ? dataObj.tcCount : "",
              unvisited:
                dataObj.outletCount !== null &&
                dataObj.visitedOutletCount !== null
                  ? dataObj.outletCount - dataObj.visitedOutletCount
                  : "",
              pcCount: dataObj.pcCount !== null ? dataObj.pcCount : "",
              visitedOutletCount:
                dataObj.visitedOutletCount !== null
                  ? dataObj.visitedOutletCount
                  : "",
            };
          });

          this.setState({
            teamCoverageFirstList,
            showRow1Details: 2,
          });
        }
      } else {
        showNotification({ msg: myConstClass.serverMsg, severity: "error" });
      }
    });
  };

  rowLinkTeamCoverageForSalesTeam = (rowData) => {
    const { showLoador, showNotification } = this.props;
    const { searchDashboardDate } = this.state;

    let teamCoverageFirstList = [];

    const salesTeamId = rowData.salesTeamId || rowData.id;

    showLoador({ loador: true });
    apiGet({
      url:
        endpoint.managerLogs +
        "/get-sales-team-and-counts-new?date=" +
        dayjs(searchDashboardDate).format("DD-MM-YYYY") +
        "&flag=1&salesTeamId=" +
        salesTeamId,
    }).then(({ data, success }) => {
      showLoador({ loador: false });
      if (success) {
        if (data && data.data) {
          teamCoverageFirstList = data.data.map((dataObj, index) => {
            return {
              index: index + 1,
              salesTeamId:
                dataObj.salesTeam !== null ? dataObj.salesTeam.id : "",
              salesTeamName:
                dataObj.salesTeam !== null &&
                dataObj.salesTeam.stockStakeHolderType !== null
                  ? dataObj.salesTeam.name +
                    " (" +
                    dataObj.salesTeam.stockStakeHolderType.prefix +
                    ")"
                  : "",
              salesTeamUserTypeId:
                dataObj.salesTeam !== null &&
                dataObj.salesTeam.stockStakeHolderType !== null &&
                dataObj.salesTeam.stockStakeHolderType.userType !== null
                  ? dataObj.salesTeam.stockStakeHolderType.userType.id
                  : "",
              address:
                dataObj.salesTeam !== null ? dataObj.salesTeam.address : "",
              distributorsCount:
                dataObj.distributorsCount !== null
                  ? dataObj.distributorsCount
                  : "",
              beatCount: dataObj.beatCount !== null ? dataObj.beatCount : "",
              outletCount:
                dataObj.outletCount !== null ? dataObj.outletCount : "",
              totalAmt:
                dataObj.totalAmt !== null
                  ? ConvertAmount({ amount: dataObj.totalAmt })
                  : "",
              tcCount: dataObj.tcCount !== null ? dataObj.tcCount : "",
              unvisited:
                dataObj.outletCount !== null &&
                dataObj.visitedOutletCount !== null
                  ? dataObj.outletCount - dataObj.visitedOutletCount
                  : "",
              pcCount: dataObj.pcCount !== null ? dataObj.pcCount : "",
              visitedOutletCount:
                dataObj.visitedOutletCount !== null
                  ? dataObj.visitedOutletCount
                  : "",
            };
          });

          this.setState({
            teamCoverageFirstList,
            showRow1Details: 2,
          });
        }
      } else {
        showNotification({ msg: myConstClass.serverMsg, severity: "error" });
      }
    });
  };

  targetCardMethod = () => {
    const { showLoador, showNotification } = this.props;
    const { selectedDate } = this.state;

    let teamCoverageFirstList = [];
    showLoador({ loador: true });
    apiGet({
      url:
        endpoint.target +
        "/get-achieved-amt-by-date?date=" +
        dayjs(selectedDate).format("DD-MM-YYYY"),
    }).then(({ data, success }) => {
      showLoador({ loador: false });
      if (success) {
        if (data && data.data) {
          teamCoverageFirstList = data.data.map((dataObj, index) => {
            const dayOfWeek = moment(dataObj.selectedDate, "DD-MM-YYYY").format(
              "dddd"
            );
            return {
              index: index + 1,
              id: dataObj.id !== null ? dataObj.id : "",
              selectedDate:
                dataObj.selectedDate !== null ? dataObj.selectedDate : "",
              day: dayOfWeek ? dayOfWeek : "",
              totalAchievedAmount:
                dataObj.totalAchievedAmount !== null
                  ? dataObj.totalAchievedAmount
                  : "",
              AchievedTarget:
                dataObj.totalAchievedAmount !== null &&
                dataObj.totalRUWiseAchievedQty !== null
                  ? dataObj.totalAchievedAmount.toFixed(2) +
                    "/" +
                    dataObj.totalRUWiseAchievedQty.toFixed(2)
                  : "",
            };
          });
          const grandTotal = teamCoverageFirstList.reduce(
            (sum, obj) => sum + Number(obj.totalAchievedAmount),
            0
          );
          this.setState({
            teamCoverageFirstList,
            showRow1Details: 5,
            grandTotal,
          });
        }
      } else {
        showNotification({ msg: myConstClass.serverMsg, severity: "error" });
      }
    });
  };

  handleChangeForSwitch = (e) => {
    this.setState({
      checked: e.target.checked,
    });
    console.debug(e.target.checked);
    const { showLoador, showNotification } = this.props;
    const { categoryIdForSummary, searchDashboardDate } = this.state;

    if (!e.target.checked) {
      let byProductWiseCatSummary = [];
      showLoador({ loador: true });
      apiGet({
        url:
          endpoint.outletOrderHeader +
          "/product-wise-total-amt-by-category-and-date?date=" +
          dayjs(searchDashboardDate).format("DD-MM-YYYY") +
          "&categoryId=" +
          categoryIdForSummary,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          if (data && data.data) {
            const grandTotal = data.data.dtoGroupWiseTotalAmtAndQty.reduce(
              (sum, dataObj) => sum + Number(dataObj.totalAmt),
              0
            );
            const grandTotalForProductWise = ConvertAmount({
                amount: grandTotal,
              }),
              byProductWiseCatSummary =
                data.data.dtoGroupWiseTotalAmtAndQty.map((dataObj, index) => {
                  return {
                    index: index + 1,
                    id: dataObj.id,
                    name: dataObj.name,
                    totalQty: dataObj.totalQty,
                    totalAmt: ConvertAmount({ amount: dataObj.totalAmt }),
                  };
                });

            this.setState({
              DataToSetForCat: [
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Category",
                  value:
                    data.data.category !== null &&
                    data.data.category.name !== null
                      ? data.data.category.name
                      : "-",
                },
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Total Amt",
                  value: grandTotalForProductWise
                    ? grandTotalForProductWise
                    : "",
                },
              ],
              byProductWiseCatSummary,
              onClickCatSummaryFlag: true,
            });
          }
        } else {
          showNotification({ msg: myConstClass.serverMsg, severity: "error" });
        }
      });
    } else {
      let packagingTypeList = [];
      showLoador({ loador: true });
      apiGet({
        url:
          endpoint.outletOrderHeader +
          "/packing-type-wise-total-amt-by-category-and-date?date=" +
          dayjs(searchDashboardDate).format("DD-MM-YYYY") +
          "&categoryId=" +
          categoryIdForSummary,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          if (data && data.data) {
            const grandTotal = data.data.dtoPackagingTypeWiseTotalList.reduce(
              (sum, dataObj) => sum + Number(dataObj.totalAmt),
              0
            );
            const grandTotalForPackagingTypeWise = ConvertAmount({
                amount: grandTotal,
              }),
              packagingTypeList = data.data.dtoPackagingTypeWiseTotalList.map(
                (dataObj, index) => {
                  return {
                    index: index + 1,
                    id: dataObj.id !== null ? dataObj.id : "",
                    name:
                      dataObj.packagingType !== null
                        ? dataObj.packagingType.name
                        : "",
                    totalQty: dataObj.totalQty !== null ? dataObj.totalQty : "",
                    totalAmt: ConvertAmount({ amount: dataObj.totalAmt }),
                  };
                }
              );

            this.setState({
              DataToSetForCat: [
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Category",
                  value:
                    data.data.category !== null &&
                    data.data.category.name !== null
                      ? data.data.category.name
                      : "-",
                },
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Total Amt",
                  value: grandTotalForPackagingTypeWise
                    ? grandTotalForPackagingTypeWise
                    : "",
                },
              ],
              packagingTypeList,
              onClickCatSummaryFlag: true,
            });
          }
        } else {
          showNotification({ msg: myConstClass.serverMsg, severity: "error" });
        }
      });
    }
  };

  getFilteredTableDataForSalesTeamList = (searchData) => {
    const { searchValueForSalesTeamList } = this.state;
    return searchData.filter((currentRow) => {
      let isValid = false;
      if (
        (currentRow["name"] &&
          currentRow["name"]
            .toString()
            .toLowerCase()
            .includes(searchValueForSalesTeamList.trim().toLowerCase())) ||
        (currentRow["district_names"] &&
          currentRow["district_names"]
            .toString()
            .toLowerCase()
            .includes(searchValueForSalesTeamList.trim().toLowerCase())) ||
        (currentRow["area_names"] &&
          currentRow["area_names"]
            .toString()
            .toLowerCase()
            .includes(searchValueForSalesTeamList.trim().toLowerCase()))
      ) {
        isValid = true;
        return true;
      }
    });
  };

  onclickUserWorkSummary = (otherTaskId) => {
    const { showLoador, showNotification } = this.props;
    const { searchDashboardDate } = this.state;

    this.setState({ otherTaskId });

    if (![5, 7, 8, 0].includes(otherTaskId)) {
      let flag = otherTaskId;
      let userWorkSummaryList = [];
      showLoador({ loador: true });
      apiGet({
        url:
          endpoint.managerLogs +
          "/get-sales-team-by-date-and-task-type-with-flag-value?date=" +
          dayjs(searchDashboardDate).format("DD-MM-YYYY") +
          "&flag=" +
          flag,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          if (data && data.data) {
            userWorkSummaryList = data.data.map((dataObj, index) => {
              return {
                index: index + 1,
                id: dataObj.id !== null ? dataObj.id : "",
                userTypeId:
                  dataObj.stockStakeHolderType !== null &&
                  dataObj.stockStakeHolderType.userType !== null &&
                  dataObj.stockStakeHolderType.userType.id !== null
                    ? dataObj.stockStakeHolderType.userType.id
                    : "",
                name:
                  dataObj.name !== null &&
                  dataObj.stockStakeHolderType !== null &&
                  dataObj.stockStakeHolderType.prefix !== null
                    ? dataObj.name +
                      " (" +
                      dataObj.stockStakeHolderType.prefix +
                      ")"
                    : "",
                address: dataObj.address !== null ? dataObj.address : "",
                areaNames: dataObj.areaNames !== null ? dataObj.areaNames : "",
                checkInTime:
                  dataObj.checkInTime !== null ? dataObj.checkInTime : "",
                checkOutTime:
                  dataObj.checkOutTime !== null ? dataObj.checkOutTime : "",
                workingHrs:
                  dataObj.workingHrs !== null ? dataObj.workingHrs : "",
                flag:
                  dataObj.flag !== null
                    ? dataObj.flag == 0
                      ? "Absent"
                      : dataObj.flag == 1
                      ? "Late"
                      : "In Time"
                    : "",
                firstCall: dataObj.firstCall !== null ? dataObj.firstCall : "",
                firstPc: dataObj.firstPc !== null ? dataObj.firstPc : "",
                scCount: dataObj.scCount !== null ? dataObj.scCount : "-",
                tcCount: dataObj.tcCount !== null ? dataObj.tcCount : "",
                pcCount: dataObj.pcCount !== null ? dataObj.pcCount : "",
                zocCount: dataObj.zocCount !== null ? dataObj.zocCount : "",
                target: dataObj.target !== null ? dataObj.target : "",
                netAmt:
                  dataObj.netAmt !== null ? dataObj.netAmt.toFixed(2) : "",
                avgAmt:
                  dataObj.avgAmt !== null ? dataObj.avgAmt.toFixed(2) : "",
                qty: dataObj.qty !== null ? dataObj.qty : "",
                lpsiPer:
                  dataObj.lpsiPer !== null ? dataObj.lpsiPer.toFixed(2) : "",
                productivityPer:
                  dataObj.productivityPer !== null
                    ? dataObj.productivityPer.toFixed(2)
                    : "",
              };
            });

            this.setState({
              DataToSetUserWorkSummary: [
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Task Name",
                  value:
                    otherTaskId == 1
                      ? "Outlet"
                      : otherTaskId == 2
                      ? "Distributor"
                      : otherTaskId == 3
                      ? "Office Work"
                      : otherTaskId == 4
                      ? "Joint Work"
                      : otherTaskId == 6
                      ? "Other"
                      : "-",
                },
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Selected Date",
                  value: dayjs(searchDashboardDate).format("DD-MM-YYYY"),
                },
              ],
              userWorkSummaryList,
              showRow1Details: 3,
            });
          }
        } else {
          showNotification({ msg: myConstClass.serverMsg, severity: "error" });
        }
      });
    }
  };

  onClickTimeSlotDetails = (rowData) => {
    console.debug(rowData);
    const { showLoador, showNotification } = this.props;
    const { searchDashboardDate } = this.state;

    let timeSlotTaskList = [];
    showLoador({ loador: true });
    apiGet({
      url:
        endpoint.managerLogs +
        "/get-by-time-slot?date=" +
        dayjs(searchDashboardDate).format("DD-MM-YYYY") +
        "&flag=" +
        rowData.otherTaskId +
        "&timeSlotId=" +
        rowData.timeSlotId,
    }).then(({ data, success }) => {
      showLoador({ loador: false });
      if (success) {
        if (data && data.data) {
          timeSlotTaskList = data.data.map((dataObj, index) => {
            return {
              index: index + 1,
              id: dataObj.id !== null ? dataObj.id : "",
              date: dataObj.date !== null ? dataObj.date : "",
              salesTeamPersonName:
                dataObj.salesTeamPersonName !== null &&
                dataObj.stockStakeHolderTypePrefix !== null
                  ? dataObj.salesTeamPersonName +
                    " (" +
                    dataObj.stockStakeHolderTypePrefix +
                    ")"
                  : "",
              salesTeamPersonAddress:
                dataObj.salesTeamPersonAddress !== null
                  ? dataObj.salesTeamPersonAddress
                  : "",
              fromTime: dataObj.fromTime !== null ? dataObj.fromTime : "",
              entityName: dataObj.entityName !== null ? dataObj.entityName : "",
              description:
                dataObj.description !== null ? dataObj.description : "",
              amount: dataObj.description !== null ? dataObj.description : "",
              extra1: dataObj.extra1 !== null ? dataObj.extra1 : "",
              checkInOut: dataObj.checkInOut !== null ? dataObj.checkInOut : "",
              otherTaskId:
                dataObj.otherTask !== null ? dataObj.otherTask.id : "",
              otherTaskName:
                dataObj.otherTask !== null ? dataObj.otherTask.name : "",
              outletId: dataObj.outletId !== null ? dataObj.outletId : "",
              remarkName: dataObj.remarkName !== null ? dataObj.remarkName : "",
              salesTeamPersonId:
                dataObj.salesTeamPersonId !== null
                  ? dataObj.salesTeamPersonId
                  : "",
              stockStakeHolderId:
                dataObj.stockStakeHolderId !== null
                  ? dataObj.stockStakeHolderId
                  : "",
              stockStakeHolderTypeId:
                dataObj.stockStakeHolderTypeId !== null
                  ? dataObj.stockStakeHolderTypeId
                  : "",
              stockStakeHolderTypeName:
                dataObj.stockStakeHolderTypeName !== null
                  ? dataObj.stockStakeHolderTypeName
                  : "",
              timeDifference:
                dataObj.timeDifference !== null ? dataObj.timeDifference : "",
              toTime: dataObj.toTime !== null ? dataObj.toTime : "",
              workingTypeId:
                dataObj.workingType !== null ? dataObj.workingType.id : "",
              workingTypeName:
                dataObj.workingType !== null ? dataObj.workingType.name : "",
              workingTypeOtherTask:
                dataObj.workingType !== null
                  ? dataObj.workingType.otherTask
                  : "",
            };
          });

          this.setState({
            taskName: rowData.otherTaskName,
            timeSlotTaskList,
            otherTaskIdForTimeSlot: rowData.otherTaskId,
            showTimeSlotDetail: true,
          });
        }
      } else {
        showNotification({ msg: myConstClass.serverMsg, severity: "error" });
      }
    });
  };

  generateExcel = () => {
    const { showLoador, showNotification } = this.props;
    const { searchDate } = this.state;
    if (navigator.onLine) {
      showLoador({ loador: true });
      downloadF({
        url:
          endpoint.adminDashboard +
          "/get-sales-teams-leave-check-in-excel-by-dates?fromDate=" +
          dayjs(searchDate).format("DD-MM-YYYY") +
          "&toDate=" +
          dayjs(searchDate).format("DD-MM-YYYY"),
        ext: "xlsx",
        openNewTab: true,
      }).then((response) => {
        showLoador({ loador: false });
        if (!response) {
          showNotification({
            msg: myConstClass.serverMsg,
            severity: "error",
          });
        } else {
        }
      });
    } else {
      showNotification({ msg: myConstClass.noInternetMsg, severity: "error" });
    }
  };

  getFormattedAmount = () => {
    const { managerDashboardData } = this.props;
    if (
      !managerDashboardData ||
      !managerDashboardData.dashboardApi ||
      !managerDashboardData.dashboardApi
        .dtoSalesPersonYearMonthTargetAndActualAmt
    ) {
      return "0(0%)";
    }

    const { mtdAchievedAmt: value, monthTragetAmt: total } =
      managerDashboardData.dashboardApi
        .dtoSalesPersonYearMonthTargetAndActualAmt;

    if (value === 0 && total === 0) {
      return "0(0%)";
    }

    if (total === 0) {
      return `${value}(100%)`;
    }

    const percentage = (value / total) * 100;
    return `${value}(${percentage.toFixed(0)}%)`;
  };

  onClickCustom = () => {
    this.setState({
      showCustomDate: !this.state.showCustomDate,
      targetAnalysisChartData: [],
      activeFlag: false,
    });
  };

  searchClaimAnalysisData = () => {
    const { claimFromDate, claimToDate } = this.state;
    const rowData = {
      flag: 1,
      fromDate: dayjs(claimFromDate).format("DD-MM-YYYY"),
      toDate: dayjs(claimToDate).format("DD-MM-YYYY"),
    };
    this.getClaimData(rowData);
  };

  searchLeaveAnalysisData = () => {
    const { leaveFromDate, leaveToDate } = this.state;
    const rowData = {
      flag: 1,
      fromDate: dayjs(leaveFromDate).format("DD-MM-YYYY"),
      toDate: dayjs(leaveToDate).format("DD-MM-YYYY"),
    };
    this.getLeaveData(rowData);
  };

  onChangeMonth = (row) => {
    this.setState({ searchMonth: row.target.value });
    const rowData = {
      flag: 1,
      monthYear: dayjs(row.target.value).format("MM-YYYY"),
      fromDate: "",
      toDate: "",
    };
    this.setState({
      targetFlag: 1,
      targetAnalysisChartData: [],
      activeFlag: false,
    });
    this.getTargetAchievementData(rowData);
  };

  onClick7Days = () => {
    this.getTargetAchievementData();
    this.setState({
      targetFlag: 0,
      targetAnalysisChartData: [],
      activeFlag: false,
    });
  };

  searchCustomDate = () => {
    const { customFromDate, customToDate } = this.state;

    const rowData = {
      flag: 2,
      fromDate: dayjs(customFromDate).format("DD-MM-YYYY"),
      toDate: dayjs(customToDate).format("DD-MM-YYYY"),
      monthYear: "",
    };
    this.setState({
      targetFlag: 2,
    });
    this.getTargetAchievementData(rowData);
  };

  onClickOpenChart = async (rowData) => {
    console.debug(rowData);
    this.setState({
      activeFlag: rowData.index,
    });
    const { showLoador, showNotification, getTargetAnalysisGraphData } =
      this.props;
    const { targetFlag, customFromDate, customToDate, searchMonth } =
      this.state;
    if (navigator.onLine) {
      showLoador({ loador: true });
      await getTargetAnalysisGraphData({
        flag: targetFlag,
        fromDate: dayjs(customFromDate).format("DD-MM-YYYY"),
        toDate: dayjs(customToDate).format("DD-MM-YYYY"),
        monthYear: dayjs(searchMonth).format("MM-YYYY"),
        salesTeamId: rowData.id,
      }).then(({ response, success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({
            msg: myConstClass.serverMsg,
            severity: "error",
          });
        } else {
          this.setState({
            targetAnalysisChartData: response ?? [],
          });
        }
      });
    } else {
      showNotification({ msg: myConstClass.noInternetMsg, severity: "error" });
    }
  };

  onClickShowInsights = () => {
    this.setState({ insightFlag: true });
    this.getClaimData();
    this.getLeaveData();
    this.getTargetAchievementData();
  };

  render() {
    const {
      alignment,
      userWorkSummaryList,
      loginPersonDataList,
      selectedDate,
      searchTerm,
      userWorkSummarySearchTerm,
      row1DetailSearch,
      searchDate,
      claimFromDate,
      claimToDate,
      searchMonth,
      DataToSetForCat,
      byProductWiseCatSummary,
      packagingTypeList,
      catWiseSummaryType,
      userSummaryList,
      teamCoverageFirstList,
      showRow1Details,
      checked,
      totalOutletCount,
      productiveCall,
      remoteOrder,
      unvisited,
      zero,
      totalAmount,
      salesAmt,
      otherTaskId,
      otherTaskIdForTimeSlot,
      timeSlotTaskList,
      timeSlotDetailSearch,
      searchDashboardDate,
      showTimeSlotDetail,
      grandTotal,
      showCustomDate,
      customFromDate,
      customToDate,
      claimAnalysisData,
      claimAnalysisSearch,
      targetAnalysisSearch,
      leaveAnalysisSearch,
      leaveAnalysisData,
      leaveToDate,
      leaveFromDate,
      targetAnalysisData,
      targetAnalysisChartData,
      activeFlag,
      insightFlag,
    } = this.state;
    const {
      managerDashboardData,
      stockStakeHolderTypeList,
      zoneList,
      areaList,
      distributorDashbourd,
      dashboardData2,
      beatList,
    } = this.props;

    const CircularProgress = this.CircularProgress;

    const userSummary = managerDashboardData?.dashboardApi?.userSummary || {};
    const total = userSummary?.totalSalesTeamCount || 0;

    const getPercentage = (count) => {
      if (!total || !count) return "0%";
      return (count / total) * 100 + "%";
    };

    const filteredUserWorkSummaryData = userWorkSummaryList.filter((row) => {
      const search = (row1DetailSearch || "").toLowerCase();
      return Object.values(row)
        .map((val) =>
          val !== null && val !== undefined ? val.toString().toLowerCase() : ""
        )
        .some((val) => val.includes(search));
    });

    const filteredClaimAnalysisData = claimAnalysisData.filter((row) => {
      const search = (claimAnalysisSearch || "").toLowerCase();
      return Object.values(row)
        .map((val) =>
          val !== null && val !== undefined ? val.toString().toLowerCase() : ""
        )
        .some((val) => val.includes(search));
    });

    const filteredTargetAnalysisData = targetAnalysisData.filter((row) => {
      const search = (targetAnalysisSearch || "").toLowerCase();
      return Object.values(row)
        .map((val) =>
          val !== null && val !== undefined ? val.toString().toLowerCase() : ""
        )
        .some((val) => val.includes(search));
    });

    const filteredLeaveAnalysisData = leaveAnalysisData.filter((row) => {
      const search = (leaveAnalysisSearch || "").toLowerCase();
      return Object.values(row)
        .map((val) =>
          val !== null && val !== undefined ? val.toString().toLowerCase() : ""
        )
        .some((val) => val.includes(search));
    });

    const filteredTimeSlotWiseWorkingDetailData = timeSlotTaskList.filter(
      (row) => {
        const search = (timeSlotDetailSearch || "").toLowerCase();
        return Object.values(row)
          .map((val) =>
            val !== null && val !== undefined
              ? val.toString().toLowerCase()
              : ""
          )
          .some((val) => val.includes(search));
      }
    );

    const row1Details =
      showRow1Details == 1 ? userSummaryList : teamCoverageFirstList;
    const filteredRow1Data = row1Details.filter((row) => {
      const search = (row1DetailSearch || "").toLowerCase();
      return Object.values(row)
        .map((val) =>
          val !== null && val !== undefined ? val.toString().toLowerCase() : ""
        )
        .some((val) => val.includes(search));
    });

    const categoryWiseList = !checked
      ? byProductWiseCatSummary
      : packagingTypeList;

    const filteredCategoryWiseData = categoryWiseList.filter((row) => {
      const search = (searchTerm || "").toLowerCase();
      return Object.values(row)
        .map((val) =>
          val !== null && val !== undefined ? val.toString().toLowerCase() : ""
        )
        .some((val) => val.includes(search));
    });
    const transformData = (input) => {
      if (!input || input.length === 0) {
        return [];
      }
      const taskNames = input[0].dtoTimeSlotAndOtherTasks.map(
        (task) => task.otherTaskName
      );

      const transformed = taskNames.map((name) => ({
        name,
        data: input.map((slot) => {
          const task = slot.dtoTimeSlotAndOtherTasks.find(
            (t) => t.otherTaskName === name
          );
          return parseInt(task ? task.count : "0", 10);
        }),
      }));

      return transformed;
    };

    // Transform the input data
    const transformedData = transformData(
      managerDashboardData.dashboardApi &&
        Object.keys(managerDashboardData.dashboardApi).length !== 0 &&
        managerDashboardData.dashboardApi.timeSlots &&
        managerDashboardData.dashboardApi.timeSlots.length != 0
        ? managerDashboardData.dashboardApi.timeSlots
        : []
    );

    const totals = filteredRow1Data.reduce(
      (obj, row) => {
        obj.distributorsTotal += row.distributorsCount || 0;
        obj.beatTotal += row.beatCount || 0;
        obj.outletTotal += row.outletCount || 0;
        obj.tcTotal += row.unvisited || 0;
        obj.pcTotal += row.pcCount || 0;
        obj.totalAmtSum += parseFloat(row.totalAmt || 0);
        return obj;
      },
      {
        distributorsTotal: 0,
        beatTotal: 0,
        outletTotal: 0,
        tcTotal: 0,
        pcTotal: 0,
        totalAmtSum: 0,
      }
    );

    return (
      <div style={this.styles.container}>
        {/* Header */}
        <div style={this.styles.header}>
          <h1 style={this.styles.title}>Dashboard</h1>
          <div style={this.styles.headerRight}>
            <input
              type="date"
              value={this.searchDashboardDate}
              onChange={(e) => this.onChangeDashboardDate(e)}
              style={{
                ...this.tableStyles.searchInput,
                backgroundColor: "#dbeeeeff",
              }}
              onFocus={(e) =>
                Object.assign(e.target.style, this.tableStyles.searchInputFocus)
              }
              onBlur={(e) =>
                Object.assign(e.target.style, {
                  borderColor: "#E5F1F9",
                  boxShadow: "none",
                })
              }
              defaultValue={dayjs().format("YYYY-MM-DD")}
              max={dayjs().format("YYYY-MM-DD")}
            />
            <span style={this.styles.currentDate}>
              Today's date: {dayjs().format("DD-MM-YYYY")}
            </span>
          </div>
        </div>

        <div style={this.tableStyles.tabContainer}>
          <div
            style={{
              ...this.tableStyles.tab,
              ...(this.state.activeDetail === "0"
                ? this.tableStyles.activeCard
                : {}),
            }}
            onClick={() => this.setState({ activeDetail: "0" })}
          >
            {"Summary"}
          </div>
          <div
            style={{
              ...this.tableStyles.tab,
              ...(this.state.activeDetail === "1"
                ? this.tableStyles.activeCard
                : {}),
            }}
            onClick={() => this.setState({ activeDetail: "1" })}
          >
            {"Overview"}
          </div>
          <div
            style={{
              ...this.tableStyles.tab,
              ...(this.state.activeDetail === "2"
                ? this.tableStyles.activeCard
                : {}),
            }}
            onClick={() => this.setState({ activeDetail: "2" })}
          >
            {"My Team"}
          </div>
          <div
            style={{
              ...this.tableStyles.tab,
              ...(this.state.activeDetail === "3"
                ? this.tableStyles.activeCard
                : {}),
            }}
            onClick={() => this.setState({ activeDetail: "3" })}
          >
            {"Insights"}
          </div>
        </div>

        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-start",
            gap: 10,
            marginBottom: "8px",
          }}
        >
          <h4
            onClick={() => {
              this.setState({ activeFilter: 0 });
            }}
            style={{
              ...this.tableStyles.inActiveFilter,
              ...(this.state.activeFilter === 0
                ? this.tableStyles.activeFilter
                : {}),
            }}
          >
            <div
              style={{
                // width: "100%",
                display: "flex",
                justifyContent: "flex-start",
                flexDirection: "row",
                // gap: 5,
              }}
            >
              <CalendarTodayIcon
                style={{
                  fontSize: "14px",
                  marginRight: "10px",
                  marginTop: "1.8px",
                }}
              />
              This week
            </div>
          </h4>
          <h4
            onClick={() => {
              this.setState({ activeFilter: 1 });
            }}
            style={{
              ...this.tableStyles.inActiveFilter,
              ...(this.state.activeFilter === 1
                ? this.tableStyles.activeFilter
                : {}),
            }}
          >
            <div
              style={{
                // width: "100%",
                display: "flex",
                justifyContent: "flex-start",
                flexDirection: "row",
                // gap: 5,
              }}
            >
              <GroupIcon
                style={{
                  fontSize: "16px",
                  marginRight: "10px",
                  marginTop: "1.8px",
                }}
              />
              Team
            </div>
          </h4>

          <h4
            onClick={() => {
              this.setState({ activeFilter: 2 });
            }}
            style={{
              ...this.tableStyles.inActiveFilter,
              ...(this.state.activeFilter === 2
                ? this.tableStyles.activeFilter
                : {}),
            }}
          >
            Client
          </h4>

          <h4
            onClick={() => {
              this.setState({ activeFilter: 3 });
            }}
            style={{
              ...this.tableStyles.inActiveFilter,
              ...(this.state.activeFilter === 3
                ? this.tableStyles.activeFilter
                : {}),
            }}
          >
            This week
          </h4>
        </div>

        <div
          style={{
            ...this.tableStyles.tabContainer,
            borderBottom: "2px solid #F1F2F4",
          }}
        />

        {/* Main Content */}
        <div style={this.styles.mainContent}>
          {/* Details Section */}
          <div style={{ ...this.styles.sectionForDetails, cursor: "pointer" }}>
            <h2 style={this.styles.sectionTitle}>Details</h2>
            <div style={this.styles.fieldGroup}>
              <div
                style={{ ...this.styles.inputFieldForName, fontWeight: "bold" }}
              >
                {loginPersonDataList[0]?.loginPersonName}
              </div>
            </div>

            <div style={this.stylesForTgtAndAchievement.card}>
              <div onClick={this.targetCardMethod}>
                <div style={this.stylesForTgtAndAchievement.headerRow}>
                  <span style={this.stylesForTgtAndAchievement.title}>
                    Achieved
                  </span>
                  <span style={this.stylesForTgtAndAchievement.badge}>MTD</span>
                </div>
                <div style={this.stylesForTgtAndAchievement.dataRow}>
                  <span style={this.stylesForTgtAndAchievement.achievedAmount}>
                    {this.getFormattedAmount()}
                  </span>
                  <span style={this.stylesForTgtAndAchievement.targetAmount}>
                    {"₹ "}
                    {ConvertAmount({
                      amount:
                        Object.keys(managerDashboardData).length !== 0 &&
                        managerDashboardData.dashboardApi &&
                        managerDashboardData.dashboardApi
                          .dtoSalesPersonYearMonthTargetAndActualAmt &&
                        managerDashboardData.dashboardApi.dtoSalesPersonYearMonthTargetAndActualAmt.monthTragetAmt.toFixed(
                          2
                        ),
                    })}
                  </span>
                </div>
                <div style={this.stylesForTgtAndAchievement.progressBar}>
                  <div
                    style={{
                      ...this.stylesForTgtAndAchievement.progressFill,
                      width:
                        managerDashboardData != null &&
                        Object.keys(managerDashboardData.dashboardApi)
                          .length !== 0 &&
                        (managerDashboardData.dashboardApi
                          .dtoSalesPersonYearMonthTargetAndActualAmt
                          .mtdAchievedAmt || 0) /
                          (managerDashboardData.dashboardApi
                            .dtoSalesPersonYearMonthTargetAndActualAmt
                            .monthTragetAmt || 0),
                    }}
                  ></div>
                </div>
              </div>
            </div>
            <div
              style={{
                ...this.stylesForTgtAndAchievement.card,
                marginTop: "2%",
                cursor: "pointer",
              }}
              onClick={this.rowLinkForTeamCoverage}
            >
              <div style={this.stylesForTgtAndAchievement.headerRow}>
                <span style={this.stylesForTgtAndAchievement.title}>
                  Team Coverage
                </span>
                <span style={this.stylesForTgtAndAchievement.badge}>MTD</span>
              </div>
              <div style={this.stylesForTgtAndAchievement.dataRow}>
                <span
                  style={{
                    ...this.stylesForTgtAndAchievement.targetAmount,
                    color: "green",
                  }}
                >
                  {"₹ "}
                  {ConvertAmount({
                    amount:
                      Object.keys(managerDashboardData).length !== 0 &&
                      managerDashboardData.dashboardApi &&
                      managerDashboardData.dashboardApi
                        .dtoSalesPersonYearMonthTargetAndActualAmt &&
                      managerDashboardData.dashboardApi.dtoSalesPersonYearMonthTargetAndActualAmt.monthTragetAmt.toFixed(
                        2
                      ),
                  })}
                </span>
              </div>
              <div style={this.stylesForTgtAndAchievement.progressBar}>
                <div style={this.stylesForTgtAndAchievement.progressFill}></div>
              </div>
            </div>
          </div>

          {/* Metrics Section */}
          <div
            style={{
              ...this.styles.sectionForUserSummary,
              padding: "24px 24px 15px 24px",
              cursor: "pointer",
            }}
            onClick={this.userSummaryCardMethod}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <h2 style={{ ...this.styles.sectionTitle, marginBottom: 0 }}>
                  User Summary
                </h2>
              </div>
              <h4
                style={{
                  fontSize: "14px",
                  backgroundColor: "#DFF6FF",
                  borderRadius: "8px",
                  padding: "7px",
                  fontWeight: 500,
                  color: "#006B8F",
                  height: "35px",
                }}
              >
                {dayjs(searchDashboardDate).format("DD-MM-YYYY")}
              </h4>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
                marginTop: "8%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "row",
                  width: "100%",
                  paddingBottom: "8%",
                }}
              >
                <div
                  style={{
                    width: "25%",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                >
                  Total
                </div>
                <div
                  style={{
                    ...this.stylesForTgtAndAchievement.progressBar,
                    width: "60%",
                    alignSelf: "center",
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      ...this.stylesForTgtAndAchievement.progressFill,
                      backgroundColor: "#004969",
                      width: getPercentage(total),
                    }}
                  ></div>
                </div>
                <div
                  style={{
                    width: "15%",
                    display: "flex",
                    justifyContent: "flex-end",
                    fontSize: "13px",
                    fontWeight: "bold",
                  }}
                >
                  {Object.keys(managerDashboardData).length !== 0 &&
                    managerDashboardData.dashboardApi &&
                    managerDashboardData.dashboardApi.userSummary &&
                    managerDashboardData.dashboardApi.userSummary
                      .totalSalesTeamCount &&
                    managerDashboardData.dashboardApi.userSummary
                      .totalSalesTeamCount}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "row",
                  width: "100%",
                  paddingBottom: "8%",
                }}
              >
                <div
                  style={{
                    width: "25%",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                >
                  Check in
                </div>
                <div
                  style={{
                    ...this.stylesForTgtAndAchievement.progressBar,
                    width: "60%",
                    alignSelf: "center",
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      ...this.stylesForTgtAndAchievement.progressFill,
                      backgroundColor: "#ecb00aff",
                      width: getPercentage(
                        userSummary?.checkInSalesTeamCount || 0
                      ),
                    }}
                  ></div>
                </div>
                <div
                  style={{
                    width: "15%",
                    display: "flex",
                    justifyContent: "flex-end",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                >
                  {Object.keys(managerDashboardData).length !== 0 &&
                    managerDashboardData.dashboardApi &&
                    managerDashboardData.dashboardApi.userSummary &&
                    managerDashboardData.dashboardApi.userSummary
                      .checkInSalesTeamCount &&
                    managerDashboardData.dashboardApi.userSummary
                      .checkInSalesTeamCount}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "row",
                  width: "100%",
                  paddingBottom: "8%",
                }}
              >
                <div
                  style={{
                    width: "25%",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                >
                  Absent
                </div>
                <div
                  style={{
                    ...this.stylesForTgtAndAchievement.progressBar,
                    width: "60%",
                    alignSelf: "center",
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      ...this.stylesForTgtAndAchievement.progressFill,
                      backgroundColor: "#FF0000",
                      width: getPercentage(
                        total -
                          (userSummary?.checkInSalesTeamCount || 0) -
                          (userSummary?.leaveApprovalPendingCount || 0)
                      ),
                    }}
                  ></div>
                </div>
                <div
                  style={{
                    width: "15%",
                    display: "flex",
                    justifyContent: "flex-end",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                >
                  {Object.keys(managerDashboardData).length !== 0 &&
                    managerDashboardData?.dashboardApi &&
                    managerDashboardData?.dashboardApi?.userSummary &&
                    managerDashboardData?.dashboardApi?.userSummary
                      ?.totalSalesTeamCount -
                      managerDashboardData?.dashboardApi?.userSummary
                        ?.checkInSalesTeamCount -
                      managerDashboardData?.dashboardApi?.userSummary
                        ?.leaveApprovalPendingCount}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "row",
                  width: "100%",
                  paddingBottom: "8%",
                }}
              >
                <div
                  style={{
                    width: "25%",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                >
                  Late
                </div>
                <div
                  style={{
                    ...this.stylesForTgtAndAchievement.progressBar,
                    width: "60%",
                    alignSelf: "center",
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      ...this.stylesForTgtAndAchievement.progressFill,
                      backgroundColor: "#ff0000",
                      width: getPercentage(
                        userSummary?.checkInLateSalesTeamCount
                      ),
                    }}
                  ></div>
                </div>
                <div
                  style={{
                    width: "15%",
                    display: "flex",
                    justifyContent: "flex-end",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                >
                  {Object.keys(managerDashboardData).length !== 0 &&
                    managerDashboardData.dashboardApi &&
                    managerDashboardData.dashboardApi.userSummary &&
                    managerDashboardData.dashboardApi.userSummary
                      .checkInLateSalesTeamCount &&
                    managerDashboardData.dashboardApi.userSummary
                      .checkInLateSalesTeamCount}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "row",
                  width: "100%",
                  paddingBottom: "8%",
                }}
              >
                <div
                  style={{
                    width: "25%",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                >
                  In-time
                </div>
                <div
                  style={{
                    ...this.stylesForTgtAndAchievement.progressBar,
                    width: "60%",
                    alignSelf: "center",
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      ...this.stylesForTgtAndAchievement.progressFill,
                      width: getPercentage(
                        userSummary?.checkInTimeSalesTeamCount
                      ),
                    }}
                  ></div>
                </div>
                <div
                  style={{
                    width: "15%",
                    display: "flex",
                    justifyContent: "flex-end",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                >
                  {Object.keys(managerDashboardData).length !== 0 &&
                    managerDashboardData.dashboardApi &&
                    managerDashboardData.dashboardApi.userSummary &&
                    managerDashboardData.dashboardApi.userSummary
                      .checkInTimeSalesTeamCount &&
                    managerDashboardData.dashboardApi.userSummary
                      .checkInTimeSalesTeamCount}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "row",
                  width: "100%",
                  paddingBottom: "8%",
                }}
              >
                <div
                  style={{
                    width: "25%",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                >
                  On leave
                </div>
                <div
                  style={{
                    ...this.stylesForTgtAndAchievement.progressBar,
                    width: "60%",
                    alignSelf: "center",
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      ...this.stylesForTgtAndAchievement.progressFill,
                      backgroundColor: "#ff0000",
                      width: getPercentage(
                        userSummary?.leaveApprovalPendingCount
                      ),
                    }}
                  ></div>
                </div>
                <div
                  style={{
                    width: "15%",
                    display: "flex",
                    justifyContent: "flex-end",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                >
                  {Object.keys(managerDashboardData).length !== 0 &&
                    managerDashboardData.dashboardApi &&
                    managerDashboardData.dashboardApi.userSummary &&
                    managerDashboardData.dashboardApi.userSummary
                      .leaveApprovalPendingCount &&
                    managerDashboardData.dashboardApi.userSummary
                      .leaveApprovalPendingCount}
                </div>
              </div>
            </div>
          </div>

          <div
            style={{ ...this.styles.sectionForUserWorkSummary, marginTop: 0 }}
          >
            {/* Sales & Manpower Table 2 starts */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <h2 style={{ ...this.styles.sectionTitle, marginBottom: 0 }}>
                  User Work Summary
                </h2>
                <h6
                  style={{
                    fontSize: "10px",
                  }}
                >
                  (Considering 1st Work Done)
                </h6>
              </div>
              <h4
                style={{
                  fontSize: "14px",
                  backgroundColor: "#DFF6FF",
                  borderRadius: "8px",
                  padding: "7px",
                  fontWeight: 500,
                  color: "#006B8F",
                  height: "35px",
                }}
              >
                {dayjs(searchDashboardDate).format("MMM-YY")}
              </h4>
            </div>

            {Object.keys(managerDashboardData?.dashboardApi).length !== 0 &&
            managerDashboardData?.dashboardApi?.dtoOtherTaskWithCounts
              .length !== 0 ? (
              <>
                <MonthlyBarChart
                  // radioValue={onChangeRadioValue}
                  height={300}
                  series={[
                    {
                      data: managerDashboardData.dashboardApi.dtoOtherTaskWithCounts.map(
                        (dataObj) =>
                          dataObj.count !== null ? dataObj.count : 0
                      ),
                    },
                  ]}
                  optionsObj={{
                    chart: {
                      type: "bar",
                      height: 365,
                      events: {
                        dataPointSelection: (event, chartContext, config) => {
                          const otherTaskId =
                            managerDashboardData.dashboardApi
                              .dtoOtherTaskWithCounts[config.dataPointIndex]
                              ?.id;
                          this.onclickUserWorkSummary(otherTaskId);
                        },
                      },
                    },

                    plotOptions: {
                      bar: {
                        columnWidth: "30%",
                        distributed: true,
                        borderRadius: 4,
                      },
                    },
                    stroke: {
                      show: true,
                      width: 2,
                      // colors: ["transparent"],
                    },
                    dataLabels: {
                      enabled: false,
                    },
                    xaxis: {
                      categories:
                        managerDashboardData.dashboardApi.dtoOtherTaskWithCounts.map(
                          (dataObj) =>
                            dataObj.name !== null ? dataObj.name : ""
                        ),
                    },
                    // yaxis: {
                    //   title: {
                    //     text: "$ (thousands)",
                    //   },
                    // },
                    fill: {
                      opacity: 1,
                    },
                    // colors: [
                    //   "#FD9600",
                    //   "#00FFFF",
                    //   "#008000",
                    //   "#DE00FD",
                    //   "#FF0000",
                    //   "#000FFF",
                    //   "#61EE9B",
                    // ],

                    tooltip: {
                      theme: "light",
                    },
                  }}
                />
              </>
            ) : (
              <NoDataFound />
            )}
          </div>
        </div>

        {showRow1Details == 1 ? (
          <div
            style={{
              ...this.styles.sectionForSalesTeam,
              height: filteredRow1Data.length != 0 ? "500px" : "auto",
              // overflow: "auto",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "row",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  width: "50%",
                }}
              >
                <h2 style={{ ...this.styles.sectionTitle, width: "30%" }}>
                  User Summary
                </h2>
                <div
                  style={{
                    ...this.tableStyles.searchContainer,
                  }}
                >
                  <input
                    type="text"
                    placeholder="Search by..."
                    value={this.row1DetailSearch}
                    onChange={(e) =>
                      this.setState({ row1DetailSearch: e.target.value })
                    }
                    style={this.tableStyles.searchInput}
                    onFocus={(e) =>
                      Object.assign(
                        e.target.style,
                        this.tableStyles.searchInputFocus
                      )
                    }
                    onBlur={(e) =>
                      Object.assign(e.target.style, {
                        borderColor: "#E5F1F9",
                        boxShadow: "none",
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div style={this.tableStyles.tableWrapper}>
              <table style={this.tableStyles.table}>
                <thead style={this.tableStyles.stickyHeader}>
                  <tr style={this.tableStyles.headerRow}>
                    <th style={this.tableStyles.headerCell}>Sr.No</th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "left",
                      }}
                    >
                      Sales Team Name
                    </th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "left",
                      }}
                    >
                      Address
                    </th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "center",
                      }}
                    >
                      Status
                    </th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "center",
                      }}
                    >
                      Check in time
                    </th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "center",
                      }}
                    >
                      Check out time
                    </th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "left",
                      }}
                    >
                      Task name
                    </th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "center",
                      }}
                    >
                      Working hours
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredRow1Data.map((row, index) => (
                    <tr
                      key={row.index}
                      style={{
                        ...this.tableStyles.dataRow,
                        ...(index % 2 === 0
                          ? this.tableStyles.alternateRow
                          : {}),
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          this.tableStyles.dataRowHover.backgroundColor)
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          index % 2 === 0
                            ? this.tableStyles.alternateRow.backgroundColor
                            : this.tableStyles.dataRow.backgroundColor)
                      }
                    >
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          textAlign: "center",
                        }}
                      >
                        {row.index}
                      </td>
                      <td
                        onClick={() => this.onClickSalesTeamName(row)}
                        style={{
                          ...this.tableStyles.dataCell,
                          cursor: "pointer",
                          textDecoration: "underline",
                          color: "#004969",
                        }}
                        width={"15%"}
                      >
                        <Link
                          color={cyanBlue}
                          component={RouterLink}
                          to={
                            localStorage.getItem("showRealTimeTracking") &&
                            localStorage.getItem("showRealTimeTracking") == 1
                              ? "/gmap-with-functionality/" +
                                row.id +
                                "/" +
                                row.userTypeId
                              : "/sales/" + row.id + "/" + row.userTypeId
                          }
                        >
                          {row.name}
                        </Link>
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          textAlign: "left",
                          position: "relative",
                          cursor: "pointer",
                        }}
                      >
                        {row.address}
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          textAlign: "center",
                        }}
                        width={"10%"}
                      >
                        {row.flag}
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          textAlign: "center",
                        }}
                        width={"10%"}
                      >
                        {row.checkInTime}
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          textAlign: "center",
                        }}
                        width={"10%"}
                      >
                        {row.checkOutTime}
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          textAlign: "left",
                        }}
                        width={"10%"}
                      >
                        {row.otherTaskName}
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          ...this.tableStyles.amountCell,
                          textAlign: "center",
                        }}
                        width={"10%"}
                      >
                        {row.workingHrs}
                      </td>
                    </tr>
                  ))}
                  {filteredRow1Data.length === 0 && (
                    <tr>
                      <td colSpan="8" style={this.tableStyles.noData}>
                        No record found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        ) : showRow1Details == 2 ? (
          <div
            style={{
              ...this.styles.sectionForSalesTeam,
              height: filteredRow1Data.length != 0 ? "500px" : "auto",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "row",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  width: "50%",
                }}
              >
                <h2 style={{ ...this.styles.sectionTitle, width: "30%" }}>
                  Team Coverage
                </h2>
                <div
                  style={{
                    ...this.tableStyles.searchContainer,
                  }}
                >
                  <input
                    type="text"
                    placeholder="Search by..."
                    value={this.row1DetailSearch}
                    onChange={(e) =>
                      this.setState({ row1DetailSearch: e.target.value })
                    }
                    style={this.tableStyles.searchInput}
                    onFocus={(e) =>
                      Object.assign(
                        e.target.style,
                        this.tableStyles.searchInputFocus
                      )
                    }
                    onBlur={(e) =>
                      Object.assign(e.target.style, {
                        borderColor: "#E5F1F9",
                        boxShadow: "none",
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div style={this.tableStyles.tableWrapper}>
              <table style={this.tableStyles.table}>
                <thead style={this.tableStyles.stickyHeader}>
                  <tr style={this.tableStyles.headerRow}>
                    <th style={this.tableStyles.headerCell}>Sr.No</th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "left",
                        width: "20%",
                      }}
                    >
                      Sales Team Name
                    </th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "left",
                      }}
                    >
                      Address
                    </th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "right",
                      }}
                    >
                      Distributor
                    </th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "right",
                      }}
                    >
                      Beats
                    </th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "right",
                      }}
                    >
                      Outlets
                    </th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "right",
                      }}
                    >
                      TC/Unvisited
                    </th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "right",
                      }}
                    >
                      PC
                    </th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "right",
                      }}
                    >
                      Value
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredRow1Data.map((row, index) => (
                    <tr
                      key={row.index}
                      style={{
                        ...this.tableStyles.dataRow,
                        ...(index % 2 === 0
                          ? this.tableStyles.alternateRow
                          : {}),
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          this.tableStyles.dataRowHover.backgroundColor)
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          index % 2 === 0
                            ? this.tableStyles.alternateRow.backgroundColor
                            : this.tableStyles.dataRow.backgroundColor)
                      }
                    >
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          textAlign: "center",
                        }}
                      >
                        {row.index}
                      </td>
                      <td
                        onClick={() =>
                          this.rowLinkTeamCoverageForSalesTeam(row)
                        }
                        style={{
                          ...this.tableStyles.dataCell,
                          cursor: "pointer",
                          textDecoration: "underline",
                          color: "#004969",
                        }}
                      >
                        <Link
                          color={cyanBlue}
                          component={RouterLink}
                          to={
                            localStorage.getItem("showRealTimeTracking") &&
                            localStorage.getItem("showRealTimeTracking") == 1
                              ? "/gmap-with-functionality/" +
                                row.salesTeamId +
                                "/" +
                                row.salesTeamUserTypeId
                              : "/sales/" +
                                row.salesTeamId +
                                "/" +
                                row.salesTeamUserTypeId
                          }
                        >
                          {row.salesTeamName}
                        </Link>
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          textAlign: "left",
                        }}
                      >
                        {row.address}
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          textAlign: "right",
                        }}
                      >
                        {row.distributorsCount}
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          textAlign: "right",
                        }}
                      >
                        {row.beatCount}
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          textAlign: "right",
                        }}
                      >
                        {row.outletCount}
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          textAlign: "right",
                        }}
                      >
                        {row.unvisited}
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          textAlign: "right",
                        }}
                      >
                        {row.pcCount}
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          ...this.tableStyles.amountCell,
                          textAlign: "right",
                        }}
                      >
                        ₹{row.totalAmt.toLocaleString()}
                      </td>
                    </tr>
                  ))}
                  {filteredRow1Data.length === 0 && (
                    <tr>
                      <td colSpan="8" style={this.tableStyles.noData}>
                        No record found.
                      </td>
                    </tr>
                  )}
                </tbody>

                <tr
                  style={{
                    background: "#f3f4f6",
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  <td style={this.tableStyles.dataCell}></td>
                  <td style={this.tableStyles.dataCell}></td>
                  <td
                    style={{
                      textAlign: "left",
                      paddingLeft: "20px",
                    }}
                  >
                    Total
                  </td>
                  <td
                    style={{
                      ...this.tableStyles.dataCell,
                      textAlign: "right",
                    }}
                  >
                    {totals.distributorsTotal}
                  </td>
                  <td
                    style={{
                      ...this.tableStyles.dataCell,
                      textAlign: "right",
                    }}
                  >
                    {totals.beatTotal}
                  </td>
                  <td
                    style={{
                      ...this.tableStyles.dataCell,
                      textAlign: "right",
                    }}
                  >
                    {totals.outletTotal}
                  </td>
                  <td
                    style={{
                      ...this.tableStyles.dataCell,
                      textAlign: "right",
                    }}
                  >
                    {totals.tcTotal}
                  </td>

                  <td
                    style={{
                      ...this.tableStyles.dataCell,
                      ...this.tableStyles.amountCell,
                      textAlign: "right",
                    }}
                  >
                    {totals.pcTotal}
                  </td>
                  <td
                    style={{
                      ...this.tableStyles.dataCell,
                      ...this.tableStyles.amountCell,
                      textAlign: "right",
                    }}
                  >
                    ₹{totals.totalAmtSum.toLocaleString()}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        ) : showRow1Details == 3 ? (
          <div
            style={{
              ...this.styles.sectionForSalesTeam,
              height: filteredRow1Data.length != 0 ? "500px" : "auto",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "row",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  width: "50%",
                }}
              >
                <h2 style={{ ...this.styles.sectionTitle, width: "40%" }}>
                  User Work Summary
                </h2>
                <div
                  style={{
                    ...this.tableStyles.searchContainer,
                  }}
                >
                  <input
                    type="text"
                    placeholder="Search by..."
                    value={this.row1DetailSearch}
                    onChange={(e) =>
                      this.setState({ row1DetailSearch: e.target.value })
                    }
                    style={this.tableStyles.searchInput}
                    onFocus={(e) =>
                      Object.assign(
                        e.target.style,
                        this.tableStyles.searchInputFocus
                      )
                    }
                    onBlur={(e) =>
                      Object.assign(e.target.style, {
                        borderColor: "#E5F1F9",
                        boxShadow: "none",
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div style={this.tableStyles.tableWrapper}>
              <table style={this.tableStyles.table}>
                <thead style={this.tableStyles.stickyHeader}>
                  <tr style={this.tableStyles.headerRow}>
                    <th style={this.tableStyles.headerCell}>Sr.No</th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "left",
                        width: "20%",
                      }}
                    >
                      Sales Team Name
                    </th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "left",
                      }}
                    >
                      Area
                    </th>
                    {otherTaskId == 1 ? (
                      <>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "right",
                          }}
                        >
                          First Call
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "right",
                          }}
                        >
                          First PC
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "right",
                          }}
                        >
                          SC
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "right",
                          }}
                        >
                          TC
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "right",
                          }}
                        >
                          PC
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "right",
                          }}
                        >
                          ZOC
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "right",
                          }}
                        >
                          Target
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "right",
                          }}
                        >
                          Net Amt
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "right",
                          }}
                        >
                          Avg Amt(MTD)
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "right",
                          }}
                        >
                          Qty
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "right",
                          }}
                        >
                          LPSI(%)
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "right",
                          }}
                        >
                          Productivity(%)
                        </th>
                      </>
                    ) : (
                      <>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "center",
                          }}
                        >
                          Check In Time
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "center",
                          }}
                        >
                          Check Out Time
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "center",
                          }}
                        >
                          Working Hours
                        </th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {filteredUserWorkSummaryData.map((row, index) => (
                    <tr
                      key={row.index}
                      style={{
                        ...this.tableStyles.dataRow,
                        ...(index % 2 === 0
                          ? this.tableStyles.alternateRow
                          : {}),
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          this.tableStyles.dataRowHover.backgroundColor)
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          index % 2 === 0
                            ? this.tableStyles.alternateRow.backgroundColor
                            : this.tableStyles.dataRow.backgroundColor)
                      }
                    >
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          textAlign: "center",
                        }}
                      >
                        {row.index}
                      </td>
                      <td
                        onClick={() =>
                          this.rowLinkTeamCoverageForSalesTeam(row)
                        }
                        style={{
                          ...this.tableStyles.dataCell,
                          cursor: "pointer",
                          textDecoration: "underline",
                          color: "#004969",
                        }}
                      >
                        <Link
                          color={cyanBlue}
                          component={RouterLink}
                          to={
                            localStorage.getItem("showRealTimeTracking") &&
                            localStorage.getItem("showRealTimeTracking") == 1
                              ? "/gmap-with-functionality/" +
                                row.id +
                                "/" +
                                row.userTypeId
                              : "/sales/" + row.id + "/" + row.userTypeId
                          }
                        >
                          {row.name}
                        </Link>
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          textAlign: "left",
                        }}
                      >
                        {row.areaNames}
                      </td>
                      {otherTaskId == 1 ? (
                        <>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "right",
                            }}
                          >
                            {row.firstCall}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "right",
                            }}
                          >
                            {row.firstPc}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "right",
                            }}
                          >
                            {row.scCount}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "right",
                            }}
                          >
                            {row.tcCount}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "right",
                            }}
                          >
                            {row.pcCount}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              ...this.tableStyles.amountCell,
                              textAlign: "right",
                            }}
                          >
                            {row.zocCount}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "right",
                            }}
                          >
                            {row.target}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "right",
                            }}
                          >
                            ₹{row.netAmt}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "right",
                            }}
                          >
                            ₹{row.avgAmt}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "right",
                            }}
                          >
                            {row.qty}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "right",
                            }}
                          >
                            {row.lpsiPer}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "right",
                            }}
                          >
                            {row.productivityPer}
                          </td>
                        </>
                      ) : (
                        <>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "right",
                            }}
                          >
                            {row.checkInTime}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "right",
                            }}
                          >
                            {row.checkOutTime}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "right",
                            }}
                          >
                            {row.workingHrs}
                          </td>
                        </>
                      )}
                    </tr>
                  ))}
                  {filteredUserWorkSummaryData.length === 0 && (
                    <tr>
                      <td colSpan="8" style={this.tableStyles.noData}>
                        No record found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        ) : showRow1Details == 5 ? (
          <div
            style={{
              ...this.styles.sectionForSalesTeam,
              height: filteredRow1Data.length != 0 ? "500px" : "auto",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "row",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  width: "50%",
                }}
              >
                <h2 style={{ ...this.styles.sectionTitle, width: "20%" }}>
                  Achieved
                </h2>
                <div
                  style={{
                    ...this.tableStyles.searchContainer,
                  }}
                >
                  <input
                    type="text"
                    placeholder="Search by..."
                    value={this.row1DetailSearch}
                    onChange={(e) =>
                      this.setState({ row1DetailSearch: e.target.value })
                    }
                    style={this.tableStyles.searchInput}
                    onFocus={(e) =>
                      Object.assign(
                        e.target.style,
                        this.tableStyles.searchInputFocus
                      )
                    }
                    onBlur={(e) =>
                      Object.assign(e.target.style, {
                        borderColor: "#E5F1F9",
                        boxShadow: "none",
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div style={this.tableStyles.tableWrapper}>
              <table style={this.tableStyles.table}>
                <thead style={this.tableStyles.stickyHeader}>
                  <tr style={this.tableStyles.headerRow}>
                    <th style={this.tableStyles.headerCell}>Sr.No</th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "left",
                      }}
                    >
                      Date
                    </th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "left",
                      }}
                    >
                      Day
                    </th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "right",
                      }}
                    >
                      Achieved Target
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredRow1Data.map((row, index) => (
                    <tr
                      key={row.index}
                      style={{
                        ...this.tableStyles.dataRow,
                        ...(index % 2 === 0
                          ? this.tableStyles.alternateRow
                          : {}),
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          this.tableStyles.dataRowHover.backgroundColor)
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          index % 2 === 0
                            ? this.tableStyles.alternateRow.backgroundColor
                            : this.tableStyles.dataRow.backgroundColor)
                      }
                    >
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          textAlign: "center",
                        }}
                      >
                        {row.index}
                      </td>
                      <td
                        // onClick={() => this.targetCardMethod(row)}
                        style={{
                          ...this.tableStyles.dataCell,
                          cursor: "pointer",

                          color: "#004969",
                        }}
                      >
                        {row.selectedDate}
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          textAlign: "left",
                        }}
                      >
                        {row.day}
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          textAlign: "right",
                        }}
                      >
                        {row.AchievedTarget}
                      </td>
                    </tr>
                  ))}
                  {filteredRow1Data.length === 0 && (
                    <tr>
                      <td colSpan="8" style={this.tableStyles.noData}>
                        No record found.
                      </td>
                    </tr>
                  )}
                </tbody>
                <tfoot>
                  <tr
                    style={{
                      background: "#f5f6f8",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    <td></td>
                    <td style={{ textAlign: "left", paddingLeft: "20px" }}>
                      Final Total :
                    </td>
                    <td></td>
                    <td style={{ textAlign: "right", padding: "8px" }}>
                      {grandTotal.toFixed(2)}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        ) : null}

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          {/* Progress MTD Section */}
          <div style={this.styles.sectionForProgessMTD}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h2 style={this.styles.sectionTitle}>Productivity</h2>
              <h4
                style={{
                  fontSize: "14px",
                  backgroundColor: "#DFF6FF",
                  borderRadius: "6px",
                  padding: "7px",
                  fontWeight: 500,
                  color: "#006B8F",
                  height: "35px",
                }}
              >
                {dayjs(searchDashboardDate).format("MMM-YY")}
              </h4>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                overflowX: "auto",
                marginTop: "3%",
              }}
            >
              <div style={this.styles.progressSection}>
                <div style={this.styles.progressRow}>
                  <div style={{ textAlign: "center" }}>
                    <div style={this.styles.progressLabel}>Percentage (%)</div>
                    <CircularProgress
                      percentage={
                        Object.keys(managerDashboardData).length !== 0 &&
                        managerDashboardData.dashboardApi &&
                        managerDashboardData.dashboardApi.mtdProductivity &&
                        managerDashboardData.dashboardApi.mtdProductivity
                      }
                      color="#3b82f6"
                    />
                  </div>
                </div>
                <div style={this.styles.progressRow}>
                  <div style={this.styles.varianceItem}>
                    <div style={this.styles.progressLabelBottom}>Call Made</div>
                    <div style={this.styles.progressValueBottom}>
                      {Object.keys(managerDashboardData).length !== 0 &&
                        managerDashboardData.dashboardApi &&
                        managerDashboardData.dashboardApi.mtdCallMade &&
                        managerDashboardData.dashboardApi.mtdCallMade}
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  backgroundColor: "white",
                  borderRadius: "8px",
                  width: "56%",
                  marginTop: "3%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "7px 0",
                    borderBottom: "1px solid #f0f0f0",
                  }}
                >
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#374151",
                    }}
                  >
                    SC
                  </span>
                  <span
                    style={{
                      padding: "6px 16px",
                      borderRadius: "20px",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "white",
                      backgroundColor: "#22c55e",
                    }}
                  >
                    {Object.keys(managerDashboardData).length !== 0 &&
                      managerDashboardData.dashboardApi &&
                      managerDashboardData.dashboardApi
                        .beatAssignCoverageOutletCount &&
                      managerDashboardData.dashboardApi
                        .beatAssignCoverageOutletCount}
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "7px 0",
                    borderBottom: "1px solid #f0f0f0",
                  }}
                >
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#374151",
                    }}
                  >
                    CP
                  </span>
                  <span
                    style={{
                      padding: "6px 16px",
                      borderRadius: "20px",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "white",
                      backgroundColor: "#3b82f6",
                    }}
                  >
                    {Object.keys(managerDashboardData).length !== 0 &&
                      managerDashboardData.dashboardApi &&
                      managerDashboardData.dashboardApi.mtdCallProductive &&
                      managerDashboardData.dashboardApi.mtdCallProductive}
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "7px 0",
                    borderBottom: "1px solid #f0f0f0",
                  }}
                >
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#374151",
                    }}
                  >
                    COV
                  </span>
                  <span
                    style={{
                      padding: "6px 16px",
                      borderRadius: "20px",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "white",
                      backgroundColor: "#ef4444",
                    }}
                  >
                    {Object.keys(managerDashboardData).length !== 0 &&
                      managerDashboardData.dashboardApi &&
                      managerDashboardData.dashboardApi
                        .beatAssignCoverageOutletCount &&
                      managerDashboardData.dashboardApi
                        .beatAssignCoverageOutletCount}
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "7px 0",
                    borderBottom: "1px solid #f0f0f0",
                  }}
                >
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#374151",
                    }}
                  >
                    FOL
                  </span>
                  <span
                    style={{
                      padding: "6px 16px",
                      borderRadius: "20px",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "white",
                      backgroundColor: "#9ca3af",
                    }}
                  >
                    {Object.keys(managerDashboardData).length !== 0 &&
                      managerDashboardData.dashboardApi &&
                      managerDashboardData.dashboardApi
                        .beatAssignProsPectiveOutletCount &&
                      managerDashboardData.dashboardApi
                        .beatAssignProsPectiveOutletCount}
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "7px 0",
                  }}
                >
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#374151",
                    }}
                  >
                    IO
                  </span>
                  <span
                    style={{
                      padding: "6px 16px",
                      borderRadius: "20px",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "white",
                      backgroundColor: "#eab308",
                    }}
                  >
                    {Object.keys(managerDashboardData).length !== 0 &&
                      managerDashboardData.dashboardApi &&
                      managerDashboardData.dashboardApi
                        .beatAssignInActiveOutletCount &&
                      managerDashboardData.dashboardApi
                        .beatAssignInActiveOutletCount}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Progress Todays Section */}
          <div style={this.styles.sectionForProgessTodays}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h2 style={this.styles.sectionTitle}>Productivity</h2>
              <h4
                style={{
                  fontSize: "14px",
                  backgroundColor: "#DFF6FF",
                  borderRadius: "6px",
                  padding: "7px",
                  fontWeight: 500,
                  color: "#006B8F",
                  height: "35px",
                }}
              >
                {dayjs(searchDashboardDate).format("DD-MM-YYYY")}
              </h4>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                overflowX: "auto",
                marginTop: "3%",
              }}
            >
              <div style={this.styles.progressSection}>
                <div style={this.styles.progressRow}>
                  <div style={{ textAlign: "center" }}>
                    <div style={this.styles.progressLabel}>Percentage (%)</div>
                    <CircularProgress
                      percentage={
                        Object.keys(managerDashboardData).length !== 0 &&
                        managerDashboardData.dashboardApi &&
                        managerDashboardData.dashboardApi.todayProductivity &&
                        managerDashboardData.dashboardApi.todayProductivity
                      }
                      color="rgba(64, 255, 0, 0.81)"
                    />
                  </div>
                </div>
                <div style={this.styles.progressRow}>
                  <div style={this.styles.varianceItem}>
                    <div style={this.styles.progressLabelBottom}>Call Made</div>
                    <div style={this.styles.progressValueBottom}>
                      {" "}
                      {Object.keys(managerDashboardData).length !== 0 &&
                        managerDashboardData.dashboardApi &&
                        managerDashboardData.dashboardApi.todayCallMade &&
                        managerDashboardData.dashboardApi.todayCallMade}
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  backgroundColor: "white",
                  borderRadius: "8px",
                  width: "56%",
                  marginTop: "3%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "7px 0",
                    borderBottom: "1px solid #f0f0f0",
                  }}
                >
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#374151",
                    }}
                  >
                    SC
                  </span>
                  <span
                    style={{
                      padding: "6px 16px",
                      borderRadius: "20px",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "white",
                      backgroundColor: "#22c55e",
                    }}
                  >
                    {Object.keys(managerDashboardData).length !== 0 &&
                      managerDashboardData.dashboardApi &&
                      managerDashboardData.dashboardApi
                        .todayBeatCoverageOutletCount &&
                      managerDashboardData.dashboardApi
                        .todayBeatCoverageOutletCount}
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "7px 0",
                    borderBottom: "1px solid #f0f0f0",
                  }}
                >
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#374151",
                    }}
                  >
                    CP
                  </span>
                  <span
                    style={{
                      padding: "6px 16px",
                      borderRadius: "20px",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "white",
                      backgroundColor: "#3b82f6",
                    }}
                  >
                    {Object.keys(managerDashboardData).length !== 0 &&
                      managerDashboardData.dashboardApi &&
                      managerDashboardData.dashboardApi.todayCallProductive &&
                      managerDashboardData.dashboardApi.todayCallProductive}
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "7px 0",
                    borderBottom: "1px solid #f0f0f0",
                  }}
                >
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#374151",
                    }}
                  >
                    COV
                  </span>
                  <span
                    style={{
                      padding: "6px 16px",
                      borderRadius: "20px",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "white",
                      backgroundColor: "#ef4444",
                    }}
                  >
                    {Object.keys(managerDashboardData).length !== 0 &&
                      managerDashboardData.dashboardApi &&
                      managerDashboardData.dashboardApi
                        .todayBeatCoverageOutletCount &&
                      managerDashboardData.dashboardApi
                        .todayBeatCoverageOutletCount}
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "7px 0",
                    borderBottom: "1px solid #f0f0f0",
                  }}
                >
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#374151",
                    }}
                  >
                    FOL
                  </span>
                  <span
                    style={{
                      padding: "6px 16px",
                      borderRadius: "20px",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "white",
                      backgroundColor: "#9ca3af",
                    }}
                  >
                    {Object.keys(managerDashboardData).length !== 0 &&
                      managerDashboardData.dashboardApi &&
                      managerDashboardData.dashboardApi
                        .todayBeatProsPectiveOutletCount &&
                      managerDashboardData.dashboardApi
                        .todayBeatProsPectiveOutletCount}
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "7px 0",
                  }}
                >
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#374151",
                    }}
                  >
                    IO
                  </span>
                  <span
                    style={{
                      padding: "6px 16px",
                      borderRadius: "20px",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "white",
                      backgroundColor: "#eab308",
                    }}
                  >
                    {Object.keys(managerDashboardData).length !== 0 &&
                      managerDashboardData.dashboardApi &&
                      managerDashboardData.dashboardApi
                        .todayBeatnInActiveOutletCount &&
                      managerDashboardData.dashboardApi
                        .todayBeatnInActiveOutletCount}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div style={this.styles.sectionForTimeslot}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h2 style={this.styles.sectionTitle}>Time Slot Wise Working</h2>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  flexDirection: "row",
                  width: "50%",
                }}
              >
                <div
                  style={{
                    paddingRight: "5%",
                  }}
                >
                  {/* <ToggleButtonGroup
                    color="primary"
                    value={alignment}
                    exclusive
                    onChange={this.handleChange}
                    size="small"
                    aria-label="Small sizes"
                    sx={{
                      "& .MuiToggleButton-root": {
                        height: "35px",
                        fontSize: "0.75rem",
                      },
                    }}
                  >
                    <ToggleButton value="0">
                      <AssessmentIcon />
                    </ToggleButton>
                    <ToggleButton value="1">
                      <TableChartIcon />
                    </ToggleButton>
                  </ToggleButtonGroup> */}
                </div>
                <h4
                  style={{
                    fontSize: "14px",
                    backgroundColor: "#DFF6FF",
                    borderRadius: "6px",
                    padding: "7px",
                    fontWeight: 500,
                    color: "#006B8F",
                    height: "35px",
                  }}
                >
                  {dayjs(searchDashboardDate).format("DD-MM-YYYY")}
                </h4>
              </div>
            </div>
            {Object.keys(managerDashboardData?.dashboardApi).length !== 0 &&
            managerDashboardData?.dashboardApi?.timeSlots.length !== 0 ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  overflow: "auto",
                }}
              >
                <ReactApexChart
                  options={{
                    chart: {
                      type: "bar",
                      stacked: true,
                      toolbar: { show: true },
                      events: {
                        dataPointSelection: (event, chartContext, config) => {
                          const otherTaskId =
                            managerDashboardData.dashboardApi.timeSlots[
                              config.dataPointIndex
                            ]?.dtoTimeSlotAndOtherTasks[config.seriesIndex];
                          this.onClickTimeSlotDetails(otherTaskId);
                        },
                      },
                    },
                    plotOptions: {
                      bar: {
                        horizontal: false,
                        borderRadius: 4,
                        columnWidth: "30%",
                      },
                    },
                    xaxis: {
                      categories:
                        managerDashboardData &&
                        Object.keys(managerDashboardData).length !== 0 &&
                        managerDashboardData.dashboardApi &&
                        managerDashboardData.dashboardApi.timeSlots &&
                        managerDashboardData.dashboardApi.timeSlots.map(
                          (dataObj) =>
                            dataObj.fromTime + " To " + dataObj.toTime
                        ),
                      fontSize: "10px",
                    },
                    legend: {
                      position: "bottom",
                    },
                    fill: {
                      opacity: 1,
                    },
                  }}
                  series={transformedData}
                  type="bar"
                  height={300}
                  width={750}
                />
              </div>
            ) : (
              <NoDataFound />
            )}
          </div>
        </div>
        {showTimeSlotDetail ? (
          <div
            style={{
              ...this.styles.sectionForSalesTeam,
              height: filteredRow1Data.length != 0 ? "500px" : "auto",
              // overflow: "auto",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "row",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  width: "50%",
                }}
              >
                <h2 style={{ ...this.styles.sectionTitle, width: "40%" }}>
                  Time Slot Wise Working Details
                </h2>
                <div
                  style={{
                    ...this.tableStyles.searchContainer,
                  }}
                >
                  <input
                    type="text"
                    placeholder="Search by..."
                    value={this.timeSlotDetailSearch}
                    onChange={(e) =>
                      this.setState({ timeSlotDetailSearch: e.target.value })
                    }
                    style={this.tableStyles.searchInput}
                    onFocus={(e) =>
                      Object.assign(
                        e.target.style,
                        this.tableStyles.searchInputFocus
                      )
                    }
                    onBlur={(e) =>
                      Object.assign(e.target.style, {
                        borderColor: "#E5F1F9",
                        boxShadow: "none",
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div style={this.tableStyles.tableWrapper}>
              <table style={this.tableStyles.table}>
                <thead style={this.tableStyles.stickyHeader}>
                  <tr style={this.tableStyles.headerRow}>
                    <th style={this.tableStyles.headerCell}>Sr.No</th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "center",
                      }}
                    >
                      Date
                    </th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "left",
                      }}
                    >
                      Sales Team Name
                    </th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "left",
                      }}
                    >
                      Address
                    </th>
                    {otherTaskIdForTimeSlot == 1 ? (
                      <>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "left",
                          }}
                        >
                          Order Time
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "left",
                          }}
                        >
                          Outlet Name
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "right",
                          }}
                        >
                          Amount
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "right",
                          }}
                        >
                          Product Count
                        </th>
                      </>
                    ) : otherTaskIdForTimeSlot == 2 ? (
                      <>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "left",
                          }}
                        >
                          Distributor Name
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "right",
                          }}
                        >
                          Amount
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "right",
                          }}
                        >
                          Product Count
                        </th>
                      </>
                    ) : (
                      <>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "left",
                          }}
                        >
                          Remark
                        </th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {filteredTimeSlotWiseWorkingDetailData.map((row, index) => (
                    <tr
                      key={row.index}
                      style={{
                        ...this.tableStyles.dataRow,
                        ...(index % 2 === 0
                          ? this.tableStyles.alternateRow
                          : {}),
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          this.tableStyles.dataRowHover.backgroundColor)
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          index % 2 === 0
                            ? this.tableStyles.alternateRow.backgroundColor
                            : this.tableStyles.dataRow.backgroundColor)
                      }
                    >
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          textAlign: "center",
                        }}
                        width={"5%"}
                      >
                        {row.index}
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          textAlign: "center",
                        }}
                        width={"15%"}
                      >
                        {row.date}
                      </td>
                      <td
                        onClick={() => this.onClickSalesTeamName(row)}
                        style={{
                          ...this.tableStyles.dataCell,
                          cursor: "pointer",
                          textDecoration: "underline",
                          color: "#004969",
                        }}
                        width={"20%"}
                      >
                        {row.salesTeamPersonName}
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          textAlign: "left",
                          position: "relative",
                          cursor: "pointer",
                        }}
                      >
                        {row.salesTeamPersonAddress}
                      </td>
                      {otherTaskIdForTimeSlot == 1 ? (
                        <>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "center",
                            }}
                            width={"10%"}
                          >
                            {row.fromTime}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "left",
                            }}
                            width={"10%"}
                          >
                            {row.entityName}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "right",
                            }}
                            width={"10%"}
                          >
                            {row.amount}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "right",
                            }}
                            width={"10%"}
                          >
                            {row.extra1}
                          </td>
                        </>
                      ) : otherTaskIdForTimeSlot == 2 ? (
                        <>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "left",
                            }}
                            width={"10%"}
                          >
                            {row.entityName}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "right",
                            }}
                            width={"10%"}
                          >
                            {row.amount}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "right",
                            }}
                            width={"10%"}
                          >
                            {row.extra1}
                          </td>
                        </>
                      ) : (
                        <>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "left",
                            }}
                            width={"25%"}
                          >
                            {row.description}
                          </td>
                        </>
                      )}
                    </tr>
                  ))}
                  {filteredTimeSlotWiseWorkingDetailData.length === 0 && (
                    <tr>
                      <td colSpan="8" style={this.tableStyles.noData}>
                        No record found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        ) : null}

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              ...this.styles.sectionForUserWorkSummary,
              overflow: "auto",
              width: "49.5%",
            }}
          >
            {/* Sales & Manpower Table 2 starts */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <h2 style={{ ...this.styles.sectionTitle, marginBottom: 0 }}>
                  Category Wise Summary
                </h2>
                <h6
                  style={{
                    fontSize: "10px",
                  }}
                >
                  (Considering 1st Work Done)
                </h6>
              </div>
              <h4
                style={{
                  fontSize: "14px",
                  backgroundColor: "#DFF6FF",
                  borderRadius: "8px",
                  padding: "7px",
                  fontWeight: 500,
                  color: "#006B8F",
                  height: "35px",
                }}
              >
                {dayjs(searchDashboardDate).format("MMM-YY")}
              </h4>
            </div>

            {managerDashboardData &&
            Object.keys(managerDashboardData).length != 0 &&
            managerDashboardData.dashboardApi &&
            managerDashboardData.dashboardApi.dtoCategoryWiseTotalAmounts &&
            managerDashboardData.dashboardApi.dtoCategoryWiseTotalAmounts
              .length != 0 ? (
              <DonutChart
                series={managerDashboardData.dashboardApi.dtoCategoryWiseTotalAmounts.map(
                  (category) => {
                    return category.totalAmt != null ? category.totalAmt : "";
                  }
                )}
                width={"600"}
                options={{
                  chart: {
                    height: "300%",
                    width: "500%",
                    type: "donut",
                    events: {
                      dataPointSelection: (event, chartContext, config) => {
                        if (
                          config &&
                          typeof config.dataPointIndex === "number" &&
                          managerDashboardData?.dashboardApi
                            ?.dtoCategoryWiseTotalAmounts &&
                          managerDashboardData.dashboardApi
                            .dtoCategoryWiseTotalAmounts.length >
                            config.dataPointIndex
                        ) {
                          const categoryId =
                            managerDashboardData.dashboardApi
                              .dtoCategoryWiseTotalAmounts[
                              config.dataPointIndex
                            ]?.category?.id;
                          if (categoryId) {
                            this.onClickCatgoryWiseSummary(categoryId);
                          }
                        }
                      },
                    },
                  },
                  animations: {
                    enabled: true,
                    easing: "easeinout",
                    speed: 1000,
                    animateGradually: {
                      enabled: true,
                      delay: 150,
                    },
                    dynamicAnimation: {
                      enabled: true,
                      speed: 100,
                    },
                  },
                  labels:
                    managerDashboardData.dashboardApi.dtoCategoryWiseTotalAmounts.map(
                      (category) => {
                        return category.category.name != null
                          ? category.category.name
                          : "";
                      }
                    ),
                  responsive: [
                    {
                      breakpoint: 480,
                      options: {
                        chart: {
                          width: 600,
                        },
                        legend: {
                          position: "bottom",
                        },
                      },
                    },
                  ],
                }}
              />
            ) : (
              <NoDataFound />
            )}
          </div>
          <div
            style={{
              ...this.styles.sectionForSalesTeam,
              width: "50%",
              padding: "17px 24px 22px 24px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "row",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  width: "50%",
                }}
              >
                <div
                  style={{
                    ...this.tableStyles.searchContainer,
                  }}
                >
                  <input
                    type="text"
                    placeholder="Search by..."
                    value={this.searchTerm}
                    onChange={(e) =>
                      this.setState({ searchTerm: e.target.value })
                    }
                    style={this.tableStyles.searchInput}
                    onFocus={(e) =>
                      Object.assign(
                        e.target.style,
                        this.tableStyles.searchInputFocus
                      )
                    }
                    onBlur={(e) =>
                      Object.assign(e.target.style, {
                        borderColor: "#E5F1F9",
                        boxShadow: "none",
                      })
                    }
                  />
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  flexDirection: "row",
                  width: "50%",
                }}
              >
                <div
                  style={{
                    ...this.tableStyles.searchContainer,
                    gap: "8px",
                    maxWidth: "400px",
                  }}
                >
                  <div
                    style={{
                      // width: "25%",
                      fontSize: "14px",
                    }}
                  >
                    By Products
                  </div>
                  <Switch
                    checked={checked}
                    onChange={this.handleChangeForSwitch}
                    slotProps={{ input: { "aria-label": "controlled" } }}
                    disabled={
                      filteredCategoryWiseData.length == 0 ? true : false
                    }
                    color="default"
                  />
                  <div
                    style={{
                      // width: "25%",
                      fontSize: "14px",
                    }}
                  >
                    By Packaging type
                  </div>
                  {/* <RadioGroup
                    row
                    aria-label="Type"
                    name="beatType"
                    value={catWiseSummaryType}
                    onChange={this.changeRadioHandler}
                    size="small"
                  >
                    <FormControlLabel
                      value={0}
                      control={<Radio />}
                      label="By Products"
                      disabled={
                        filteredCategoryWiseData.length == 0 ? true : false
                      }
                    />
                    <FormControlLabel
                      value={1}
                      control={<Radio />}
                      label="By Packaging Type"
                      disabled={
                        filteredCategoryWiseData.length == 0 ? true : false
                      }
                    />
                  </RadioGroup> */}
                </div>
              </div>
            </div>

            <div style={this.tableStyles.tableWrapper}>
              <table style={this.tableStyles.table}>
                <thead style={this.tableStyles.stickyHeader}>
                  <tr style={this.tableStyles.headerRow}>
                    <th style={this.tableStyles.headerCell}>Sr.No</th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "left",
                      }}
                    >
                      {!checked ? "Product Name" : "Packaging type name"}
                    </th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "right",
                      }}
                    >
                      Quantity
                    </th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "right",
                      }}
                    >
                      Total Amount
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCategoryWiseData.map((row, index) => (
                    <tr
                      key={row.index}
                      style={{
                        ...this.tableStyles.dataRow,
                        ...(index % 2 === 0
                          ? this.tableStyles.alternateRow
                          : {}),
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          this.tableStyles.dataRowHover.backgroundColor)
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          index % 2 === 0
                            ? this.tableStyles.alternateRow.backgroundColor
                            : this.tableStyles.dataRow.backgroundColor)
                      }
                    >
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          textAlign: "center",
                        }}
                      >
                        {row?.index}
                      </td>
                      <td
                        onClick={() => this.onClickSalesTeamName(row)}
                        style={{
                          ...this.tableStyles.dataCell,
                          textAlign: "left",
                        }}
                      >
                        {row?.name}
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          textAlign: "right",
                        }}
                      >
                        {row?.totalQty.toLocaleString()}
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          ...this.tableStyles.amountCell,
                          textAlign: "right",
                        }}
                      >
                        ₹{row?.totalAmt.toLocaleString()}
                      </td>
                    </tr>
                  ))}
                  {/* {filteredSalesData.length > 0 && (
                    <tr style={{ background: "#f3f4f6", fontWeight: "bold" }}>
                      <td style={this.tableStyles.dataCell}></td>
                      <td style={this.tableStyles.dataCell}></td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          textAlign: "right",
                        }}
                      >
                        Total
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          textAlign: "right",
                        }}
                      >
                        {filteredSalesData.reduce(
                          (sum, row) => sum + (row.totalOutlet || 0),
                          0
                        )}
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          textAlign: "right",
                        }}
                      >
                        {filteredSalesData.reduce(
                          (sum, row) => sum + (row.productiveCall || 0),
                          0
                        )}
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          textAlign: "right",
                        }}
                      >
                        {filteredSalesData.reduce(
                          (sum, row) => sum + (row.unvisitedOutlet || 0),
                          0
                        )}
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          textAlign: "right",
                        }}
                      >
                        {filteredSalesData.reduce(
                          (sum, row) => sum + (row.zeroOrder || 0),
                          0
                        )}
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          ...this.tableStyles.amountCell,
                          textAlign: "right",
                        }}
                      >
                        ₹
                        {filteredSalesData
                          .reduce(
                            (sum, row) => sum + (row.totalOrderAmount || 0),
                            0
                          )
                          .toLocaleString()}
                      </td>
                      <td
                        style={{
                          ...this.tableStyles.dataCell,
                          ...this.tableStyles.amountCell,
                          textAlign: "right",
                        }}
                      >
                        ₹
                        {filteredSalesData
                          .reduce(
                            (sum, row) => sum + (row.totalSalesAmount || 0),
                            0
                          )
                          .toLocaleString()}
                      </td>
                    </tr>
                  )} */}
                  {filteredCategoryWiseData.length === 0 && (
                    <tr>
                      <td colSpan="4" style={this.tableStyles.noData}>
                        No record found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              overflow: "auto",
            }}
          >
            <table style={this.tableStyles.table}>
              <thead>
                <tr style={this.tableStyles.headerRow}>
                  <th style={this.tableStyles.headerCell}>Sr.No</th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      textAlign: "left",
                    }}
                  >
                    Sales Team Name
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      textAlign: "right",
                    }}
                  >
                    Beat Count
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      textAlign: "right",
                    }}
                  >
                    Total Outlet
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      textAlign: "right",
                    }}
                  >
                    Productive Call
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      textAlign: "right",
                    }}
                  >
                    Unvisited Outlet
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      textAlign: "right",
                    }}
                  >
                    Zero Order
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      textAlign: "right",
                    }}
                  >
                    Total Order Amount
                  </th>
                  <th
                    style={{
                      ...this.tableStyles.headerCell,
                      textAlign: "right",
                    }}
                  >
                    Total Sales Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredSalesData.map((row, index) => (
                  <tr
                    key={row.srNo}
                    style={{
                      ...this.tableStyles.dataRow,
                      ...(index % 2 === 0 ? this.tableStyles.alternateRow : {}),
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor =
                        this.tableStyles.dataRowHover.backgroundColor)
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor =
                        index % 2 === 0
                          ? this.tableStyles.alternateRow.backgroundColor
                          : this.tableStyles.dataRow.backgroundColor)
                    }
                  >
                    <td
                      style={{
                        ...this.tableStyles.dataCell,
                        textAlign: "center",
                      }}
                    >
                      {row.srNo}
                    </td>
                    <td
                      onClick={() => this.onClickSalesTeamName(row)}
                      style={{
                        ...this.tableStyles.dataCell,
                        cursor: "pointer",
                        textDecoration: "underline",
                        color: "#004969",
                      }}
                    >
                      {row.teamName}
                    </td>
                    <td
                      style={{
                        ...this.tableStyles.dataCell,
                        textAlign: "right",
                        position: "relative",
                        cursor: "pointer",
                      }}
                      onMouseEnter={(e) => {
                        clearTimeout(this.tooltipTimeout);
                        this.showTooltip(e, row.beatName || "No Beat Name");
                      }}
                      onMouseLeave={this.hideTooltipWithDelay}
                    >
                      {row.beatCount}
                    </td>
                    <td
                      style={{
                        ...this.tableStyles.dataCell,
                        textAlign: "right",
                      }}
                    >
                      {row.totalOutlet}
                    </td>
                    <td
                      style={{
                        ...this.tableStyles.dataCell,
                        textAlign: "right",
                      }}
                    >
                      {row.productiveCall}
                    </td>
                    <td
                      style={{
                        ...this.tableStyles.dataCell,
                        textAlign: "right",
                      }}
                    >
                      {row.unvisitedOutlet}
                    </td>
                    <td
                      style={{
                        ...this.tableStyles.dataCell,
                        textAlign: "right",
                      }}
                    >
                      {row.zeroOrder}
                    </td>
                    <td
                      style={{
                        ...this.tableStyles.dataCell,
                        ...this.tableStyles.amountCell,
                        textAlign: "right",
                      }}
                    >
                      ₹{row.totalOrderAmount.toLocaleString()}
                    </td>
                    <td
                      style={{
                        ...this.tableStyles.dataCell,
                        ...this.tableStyles.amountCell,
                        textAlign: "right",
                      }}
                    >
                      ₹{row.totalSalesAmount.toLocaleString()}
                    </td>
                  </tr>
                ))}
                {filteredSalesData.length > 0 && (
                  <tr style={{ background: "#f3f4f6", fontWeight: "bold" }}>
                    <td style={this.tableStyles.dataCell}></td>
                    <td style={this.tableStyles.dataCell}></td>
                    <td
                      style={{
                        ...this.tableStyles.dataCell,
                        textAlign: "right",
                      }}
                    >
                      Total
                    </td>
                    <td
                      style={{
                        ...this.tableStyles.dataCell,
                        textAlign: "right",
                      }}
                    >
                      {filteredSalesData.reduce(
                        (sum, row) => sum + (row.totalOutlet || 0),
                        0
                      )}
                    </td>
                    <td
                      style={{
                        ...this.tableStyles.dataCell,
                        textAlign: "right",
                      }}
                    >
                      {filteredSalesData.reduce(
                        (sum, row) => sum + (row.productiveCall || 0),
                        0
                      )}
                    </td>
                    <td
                      style={{
                        ...this.tableStyles.dataCell,
                        textAlign: "right",
                      }}
                    >
                      {filteredSalesData.reduce(
                        (sum, row) => sum + (row.unvisitedOutlet || 0),
                        0
                      )}
                    </td>
                    <td
                      style={{
                        ...this.tableStyles.dataCell,
                        textAlign: "right",
                      }}
                    >
                      {filteredSalesData.reduce(
                        (sum, row) => sum + (row.zeroOrder || 0),
                        0
                      )}
                    </td>
                    <td
                      style={{
                        ...this.tableStyles.dataCell,
                        ...this.tableStyles.amountCell,
                        textAlign: "right",
                      }}
                    >
                      ₹
                      {filteredSalesData
                        .reduce(
                          (sum, row) => sum + (row.totalOrderAmount || 0),
                          0
                        )
                        .toLocaleString()}
                    </td>
                    <td
                      style={{
                        ...this.tableStyles.dataCell,
                        ...this.tableStyles.amountCell,
                        textAlign: "right",
                      }}
                    >
                      ₹
                      {filteredSalesData
                        .reduce(
                          (sum, row) => sum + (row.totalSalesAmount || 0),
                          0
                        )
                        .toLocaleString()}
                    </td>
                  </tr>
                )}
                {filteredSalesData.length === 0 && (
                  <tr>
                    <td colSpan="9" style={this.tableStyles.noData}>
                      No matching teams found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div> */}
          </div>
        </div>

        <div
          style={{
            ...this.styles.sectionForSalesTeam,
            height: dashboardData2?.salesInfo.length != 0 ? "564px" : "auto",
            marginTop: "1%",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                flexDirection: "row",
                width: "50%",
              }}
            >
              <h2 style={{ ...this.styles.sectionTitle, width: "30%" }}>
                Sales Team List
              </h2>
              <div
                style={{
                  ...this.tableStyles.searchContainer,
                }}
              >
                <input
                  type="text"
                  placeholder="Search by Sales Team Name..."
                  value={this.searchValueForSalesTeamList}
                  onChange={(e) =>
                    this.setState({
                      searchValueForSalesTeamList: e.target.value,
                    })
                  }
                  style={this.tableStyles.searchInput}
                  onFocus={(e) =>
                    Object.assign(
                      e.target.style,
                      this.tableStyles.searchInputFocus
                    )
                  }
                  onBlur={(e) =>
                    Object.assign(e.target.style, {
                      borderColor: "#E5F1F9",
                      boxShadow: "none",
                    })
                  }
                />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                flexDirection: "row",
                width: "50%",
              }}
            >
              <div
                style={{
                  ...this.tableStyles.searchContainer,
                  gap: "8px",
                  maxWidth: "400px",
                }}
              >
                <input
                  type="date"
                  value={this.searchDate}
                  onChange={(e) =>
                    this.setState({ searchDate: e.target.value })
                  }
                  style={this.tableStyles.searchInput}
                  onFocus={(e) =>
                    Object.assign(
                      e.target.style,
                      this.tableStyles.searchInputFocus
                    )
                  }
                  onBlur={(e) =>
                    Object.assign(e.target.style, {
                      borderColor: "#E5F1F9",
                      boxShadow: "none",
                    })
                  }
                  defaultValue={dayjs().format("YYYY-MM-DD")}
                  max={dayjs().format("YYYY-MM-DD")}
                />
                <button
                  style={{
                    padding: "7px 16px",
                    borderRadius: "6px",
                    border: "none",
                    background: "#2563eb",
                    color: "#fff",
                    fontWeight: 500,
                    cursor: "pointer",
                  }}
                  onClick={this.searchSalesTeamData}
                >
                  Search
                </button>
                <button
                  style={{
                    padding: "7px 16px",
                    borderRadius: "6px",
                    border: "none",
                    background: "#22c55e",
                    color: "#fff",
                    fontWeight: 500,
                    cursor: "pointer",
                  }}
                  onClick={this.generateExcel}
                >
                  Excel
                </button>
              </div>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              overflow: "auto",
            }}
          >
            <div style={this.tableStyles.tabContainer}>
              <div
                style={{
                  ...this.tableStyles.tab,
                  ...(this.state.activeTab === "0"
                    ? this.tableStyles.activeTab
                    : {}),
                }}
                onClick={() => this.setState({ activeTab: "0" })}
              >
                {"All" + " ( " + dashboardData2?.salesInfo.length + " ) "}
              </div>
              <div
                style={{
                  ...this.tableStyles.tab,
                  ...(this.state.activeTab === "1"
                    ? this.tableStyles.activeTab
                    : {}),
                }}
                onClick={() => this.setState({ activeTab: "1" })}
              >
                {"Present" +
                  " ( " +
                  dashboardData2?.salesInfo.filter(
                    (row) => row.attendenceStatus == 1
                  ).length +
                  " ) "}
              </div>
              <div
                style={{
                  ...this.tableStyles.tab,
                  ...(this.state.activeTab === "2"
                    ? this.tableStyles.activeTab
                    : {}),
                }}
                onClick={() => this.setState({ activeTab: "2" })}
              >
                {"Absent" +
                  " ( " +
                  dashboardData2?.salesInfo.filter((row) => row.isAbsent == 1)
                    .length +
                  " ) "}
              </div>
              <div
                style={{
                  ...this.tableStyles.tab,
                  ...(this.state.activeTab === "3"
                    ? this.tableStyles.activeTab
                    : {}),
                }}
                onClick={() => this.setState({ activeTab: "3" })}
              >
                {"Late" +
                  " ( " +
                  dashboardData2?.salesInfo.filter(
                    (row) => row.checkInStatus == 1
                  ).length +
                  " ) "}
              </div>
              <div
                style={{
                  ...this.tableStyles.tab,
                  ...(this.state.activeTab === "4"
                    ? this.tableStyles.activeTab
                    : {}),
                }}
                onClick={() => this.setState({ activeTab: "4" })}
              >
                {"On Leave" +
                  " ( " +
                  dashboardData2?.salesInfo.filter((row) => row.isLeave == 1)
                    .length +
                  " ) "}
              </div>
            </div>
            <div style={this.tableStyles.tableWrapper}>
              <table style={this.tableStyles.table}>
                <thead style={this.tableStyles.stickyHeader}>
                  <tr style={this.tableStyles.headerRow}>
                    <th style={this.tableStyles.headerCell}>Sr.No</th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "left",
                      }}
                    >
                      Sales Team Name
                    </th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "right",
                      }}
                    >
                      Beat Count
                    </th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "right",
                      }}
                    >
                      Total Outlet
                    </th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "right",
                      }}
                    >
                      Productive Call
                    </th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "right",
                      }}
                    >
                      Unvisited Outlet
                    </th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "right",
                      }}
                    >
                      Zero Order
                    </th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "right",
                      }}
                    >
                      Total Order Amount
                    </th>
                    <th
                      style={{
                        ...this.tableStyles.headerCell,
                        textAlign: "right",
                      }}
                    >
                      Total Sales Amount
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {dashboardData2.salesInfo.length != 0 &&
                    this.getFilteredTableDataForSalesTeamList(
                      this.state.activeTab == "0"
                        ? dashboardData2?.salesInfo
                        : this.state.activeTab == "1"
                        ? dashboardData2?.salesInfo.filter(
                            (row) => row.attendenceStatus == 1
                          )
                        : this.state.activeTab == "2"
                        ? dashboardData2?.salesInfo.filter(
                            (row) => row.isAbsent == 1
                          )
                        : this.state.activeTab == "3"
                        ? dashboardData2?.salesInfo.filter(
                            (row) => row.checkInStatus == 1
                          )
                        : dashboardData2?.salesInfo.filter(
                            (row) => row.isLeave == 1
                          )
                    )?.map((row, index) => (
                      <tr
                        key={index + 1}
                        style={{
                          ...this.tableStyles.dataRow,
                          ...(index % 2 === 0
                            ? this.tableStyles.alternateRow
                            : {}),
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            this.tableStyles.dataRowHover.backgroundColor)
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            index % 2 === 0
                              ? this.tableStyles.alternateRow.backgroundColor
                              : this.tableStyles.dataRow.backgroundColor)
                        }
                      >
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            textAlign: "center",
                          }}
                        >
                          {index + 1}
                        </td>
                        <td
                          onClick={() => this.onClickSalesTeamName(row)}
                          style={{
                            ...this.tableStyles.dataCell,
                            cursor: "pointer",
                            textDecoration: "underline",
                            color: "#004969",
                          }}
                        >
                          <Link
                            color={cyanBlue}
                            component={RouterLink}
                            to={
                              localStorage.getItem("showRealTimeTracking") &&
                              localStorage.getItem("showRealTimeTracking") == 1
                                ? "/gmap-with-functionality/" +
                                  row.salesTeamId +
                                  "/" +
                                  row.userTypeId
                                : "/sales/" +
                                  row.salesTeamId +
                                  "/" +
                                  row.userTypeId
                            }
                          >
                            {row.name}
                          </Link>
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            textAlign: "right",
                            position: "relative",
                            cursor: "pointer",
                            ...this.tableStyles.amountCell,
                          }}
                          onMouseEnter={(e) => {
                            clearTimeout(this.tooltipTimeout);
                            this.showTooltip(
                              e,
                              row.beats != 0 ? row.beats : "Beat not found"
                            );
                          }}
                          onMouseLeave={this.hideTooltipWithDelay}
                        >
                          {row.beatCount}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            textAlign: "right",
                          }}
                        >
                          {row.totalOutletCount}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            textAlign: "right",
                          }}
                        >
                          {row.productiveCall}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            textAlign: "right",
                          }}
                        >
                          {row.unvisitedOutletCount}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            textAlign: "right",
                          }}
                        >
                          {row.zeroOrderCount}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            ...this.tableStyles.amountCell,
                            textAlign: "right",
                          }}
                        >
                          ₹{row.totalAmount.toLocaleString()}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            ...this.tableStyles.amountCell,
                            textAlign: "right",
                          }}
                        >
                          ₹{row.totalSalesAmt.toLocaleString()}
                        </td>
                      </tr>
                    ))}
                  {dashboardData2.salesInfo.length != 0 &&
                    this.getFilteredTableDataForSalesTeamList(
                      this.state.activeTab == "0"
                        ? dashboardData2?.salesInfo
                        : this.state.activeTab == "1"
                        ? dashboardData2?.salesInfo.filter(
                            (row) => row.attendenceStatus == 1
                          )
                        : this.state.activeTab == "2"
                        ? dashboardData2?.salesInfo.filter(
                            (row) => row.isAbsent == 1
                          )
                        : this.state.activeTab == "3"
                        ? dashboardData2?.salesInfo.filter(
                            (row) => row.checkInStatus == 1
                          )
                        : dashboardData2?.salesInfo.filter(
                            (row) => row.isLeave == 1
                          )
                    )?.length > 0 && (
                      <tr style={{ background: "#f3f4f6", fontWeight: "bold" }}>
                        <td style={this.tableStyles.dataCell}></td>
                        <td style={this.tableStyles.dataCell}></td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            textAlign: "right",
                          }}
                        >
                          Total
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            textAlign: "right",
                          }}
                        >
                          {totalOutletCount}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            textAlign: "right",
                          }}
                        >
                          {productiveCall}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            textAlign: "right",
                          }}
                        >
                          {unvisited}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            textAlign: "right",
                          }}
                        >
                          {zero}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            ...this.tableStyles.amountCell,
                            textAlign: "right",
                          }}
                        >
                          ₹{(+totalAmount).toLocaleString()}
                        </td>
                        <td
                          style={{
                            ...this.tableStyles.dataCell,
                            ...this.tableStyles.amountCell,
                            textAlign: "right",
                          }}
                        >
                          ₹{(+salesAmt).toLocaleString()}
                        </td>
                      </tr>
                    )}
                  {dashboardData2.salesInfo.length != 0 &&
                    this.getFilteredTableDataForSalesTeamList(
                      this.state.activeTab == "0"
                        ? dashboardData2?.salesInfo
                        : this.state.activeTab == "1"
                        ? dashboardData2?.salesInfo.filter(
                            (row) => row.attendenceStatus == 1
                          )
                        : this.state.activeTab == "2"
                        ? dashboardData2?.salesInfo.filter(
                            (row) => row.isAbsent == 1
                          )
                        : this.state.activeTab == "3"
                        ? dashboardData2?.salesInfo.filter(
                            (row) => row.checkInStatus == 1
                          )
                        : dashboardData2?.salesInfo.filter(
                            (row) => row.isLeave == 1
                          )
                    )?.length === 0 && (
                      <tr>
                        <td colSpan="9" style={this.tableStyles.noData}>
                          No matching teams found.
                        </td>
                      </tr>
                    )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {insightFlag ? (
          <>
            <h1 style={{ ...this.styles.title, marginTop: "1%" }}>Insights</h1>

            <div
              style={{
                backgroundColor: "white",
                // padding: "24px",
                width: "100%",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                // marginBottom: "1%",
                marginTop: "0.4%",
                height: "548px",
              }}
            >
              {/* mainHeight="564px" mapHeight="548px" */}
              <GMapNew mainHeight="100%" showBackBtn={false} />
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  ...this.styles.sectionForSalesTeam,
                  width: "49.5%",
                  padding: "17px 24px 22px 24px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      flexDirection: "row",
                      width: "40%",
                    }}
                  >
                    <div
                      style={{
                        ...this.tableStyles.searchContainer,
                        maxWidth: "250px",
                      }}
                    >
                      <input
                        type="text"
                        placeholder="Search by..."
                        value={targetAnalysisSearch}
                        onChange={(e) =>
                          this.setState({
                            targetAnalysisSearch: e.target.value,
                          })
                        }
                        style={this.tableStyles.searchInput}
                        onFocus={(e) =>
                          Object.assign(
                            e.target.style,
                            this.tableStyles.searchInputFocus
                          )
                        }
                        onBlur={(e) =>
                          Object.assign(e.target.style, {
                            borderColor: "#E5F1F9",
                            boxShadow: "none",
                          })
                        }
                      />
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      flexDirection: "row",
                      width: "60%",
                    }}
                  >
                    <div
                      style={{
                        ...this.tableStyles.searchContainer,
                        gap: "8px",
                        maxWidth: "600px",
                      }}
                    >
                      {showCustomDate ? (
                        <>
                          <input
                            type="date"
                            value={customFromDate}
                            onChange={(e) =>
                              this.setState({ customFromDate: e.target.value })
                            }
                            style={this.tableStyles.searchInput}
                            onFocus={(e) =>
                              Object.assign(
                                e.target.style,
                                this.tableStyles.searchInputFocus
                              )
                            }
                            onBlur={(e) =>
                              Object.assign(e.target.style, {
                                borderColor: "#E5F1F9",
                                boxShadow: "none",
                              })
                            }
                            defaultValue={dayjs().format("YYYY-MM-DD")}
                            // max={dayjs().format("YYYY-MM-DD")}
                          />
                          <input
                            type="date"
                            value={customToDate}
                            onChange={(e) =>
                              this.setState({ customToDate: e.target.value })
                            }
                            style={this.tableStyles.searchInput}
                            onFocus={(e) =>
                              Object.assign(
                                e.target.style,
                                this.tableStyles.searchInputFocus
                              )
                            }
                            onBlur={(e) =>
                              Object.assign(e.target.style, {
                                borderColor: "#E5F1F9",
                                boxShadow: "none",
                              })
                            }
                            defaultValue={dayjs().format("YYYY-MM-DD")}
                            min={customFromDate}
                            // max={dayjs(fromDate).format("YYYY-MM-DD")}
                          />
                          <button
                            style={{
                              padding: "7px 16px",
                              borderRadius: "6px",
                              border: "none",
                              background: "#2563eb",
                              color: "#fff",
                              fontWeight: 500,
                              cursor: "pointer",
                            }}
                            onClick={this.searchCustomDate}
                          >
                            Search
                          </button>
                          <CloseIcon
                            style={{
                              cursor: "pointer",
                            }}
                            onClick={this.onClickCustom}
                          />
                        </>
                      ) : (
                        <>
                          <button
                            style={{
                              padding: "7px 16px",
                              borderRadius: "6px",
                              border: "none",
                              background: "#2563eb",
                              color: "#fff",
                              fontWeight: 500,
                              cursor: "pointer",
                            }}
                            onClick={this.onClick7Days}
                          >
                            7 Days
                          </button>
                          <input
                            type="month"
                            value={searchMonth}
                            onChange={(e) => this.onChangeMonth(e)}
                            style={{
                              ...this.tableStyles.searchInput,
                              width: "45%",
                            }}
                            onFocus={(e) =>
                              Object.assign(
                                e.target.style,
                                this.tableStyles.searchInputFocus
                              )
                            }
                            onBlur={(e) =>
                              Object.assign(e.target.style, {
                                borderColor: "#E5F1F9",
                                boxShadow: "none",
                              })
                            }
                            defaultValue={dayjs().format("YYYY-MM")}
                            max={dayjs().format("YYYY-MM")}
                          />
                          <button
                            style={{
                              padding: "7px 16px",
                              borderRadius: "6px",
                              border: "none",
                              background: "#22c55e",
                              color: "#fff",
                              fontWeight: 500,
                              cursor: "pointer",
                            }}
                            onClick={this.onClickCustom}
                          >
                            Custom
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                <div style={this.tableStyles.tableWrapper}>
                  <table style={this.tableStyles.table}>
                    <thead style={this.tableStyles.stickyHeader}>
                      <tr style={this.tableStyles.headerRow}>
                        <th style={this.tableStyles.headerCell}>Sr.No</th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "left",
                          }}
                        >
                          Sales Team Name
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "right",
                          }}
                        >
                          Achieved
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "right",
                          }}
                        >
                          Target
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "right",
                          }}
                        >
                          Distance(KM)
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "center",
                          }}
                        >
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredTargetAnalysisData.map((row, index) => (
                        <tr
                          key={row.index}
                          style={{
                            ...this.tableStyles.dataRow,
                            ...(activeFlag == row?.index
                              ? this.tableStyles.activeRow
                              : {}),
                            // ...(index % 2 === 0
                            //   ? this.tableStyles.alternateRow
                            //   : {}),
                          }}
                          // onMouseEnter={(e) =>
                          //   (e.currentTarget.style.backgroundColor =
                          //     this.tableStyles.dataRowHover.backgroundColor)
                          // }
                          // onMouseLeave={(e) =>
                          //   (e.currentTarget.style.backgroundColor =
                          //     index % 2 === 0
                          //       ? this.tableStyles.alternateRow.backgroundColor
                          //       : this.tableStyles.dataRow.backgroundColor)
                          // }
                        >
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "center",
                            }}
                          >
                            {row?.index}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "left",
                            }}
                          >
                            {row?.name} ({row?.stockStakeHolderTypeName})
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              ...this.tableStyles.amountCell,
                              textAlign: "right",
                            }}
                          >
                            ₹{row?.achieveAmt.toLocaleString()}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              ...this.tableStyles.amountCell,
                              textAlign: "right",
                            }}
                          >
                            ₹{row?.targetAmt.toLocaleString()}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              ...this.tableStyles.amountCell,
                              textAlign: "right",
                            }}
                          >
                            {row?.distanceInKm.toFixed(2)}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "center",
                              cursor: "pointer",
                            }}
                          >
                            <AssessmentIcon
                              style={{
                                color: "#004969",
                              }}
                              onClick={(e) => this.onClickOpenChart(row)}
                            />
                          </td>
                        </tr>
                      ))}
                      {filteredTargetAnalysisData.length === 0 && (
                        <tr>
                          <td colSpan="6" style={this.tableStyles.noData}>
                            No record found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              <div
                style={{
                  ...this.styles.sectionForUserWorkSummary,
                  overflow: "auto",
                  width: "50%",
                }}
              >
                {/* Sales & Manpower Table 2 starts */}
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    <h2
                      style={{ ...this.styles.sectionTitle, marginBottom: 0 }}
                    >
                      Target Vs Achievement
                    </h2>
                  </div>
                </div>

                {targetAnalysisChartData.length != 0 ? (
                  <MonthlyBarChart
                    // radioValue={onChangeRadioValue}
                    height={400}
                    type={"line"}
                    series={[
                      {
                        data: targetAnalysisChartData.map((category) => {
                          return category.achieveAmt != null
                            ? +category.achieveAmt
                            : "";
                        }),
                      },
                    ]}
                    optionsObj={{
                      chart: {
                        type: "line",
                        height: 400,
                      },

                      plotOptions: {
                        bar: {
                          columnWidth: "30%",
                          distributed: true,
                        },
                      },
                      stroke: {
                        show: true,
                        width: 2,
                        // colors: ["transparent"],
                      },
                      dataLabels: {
                        enabled: false,
                      },
                      xaxis: {
                        categories: targetAnalysisChartData?.map((dataObj) =>
                          dataObj.date !== null ? dataObj.date : 0
                        ),
                      },
                      // yaxis: {
                      // title: {
                      // text: "$ (thousands)",
                      // },
                      // },
                      fill: {
                        opacity: 1,
                      },
                      colors: [
                        "#FD9600",
                        "#00FFFF",
                        "#008000",
                        "#DE00FD",
                        "#FF0000",
                        "#000FFF",
                        "#61EE9B",
                      ],
                      animations: {
                        enabled: true,
                        easing: "easeinout",
                        speed: 1000,
                        animateGradually: {
                          enabled: true,
                          delay: 150,
                        },
                        dynamicAnimation: {
                          enabled: true,
                          speed: 100,
                        },
                      },
                      tooltip: {
                        theme: "light",
                      },
                    }}
                  />
                ) : (
                  <NoDataFound />
                )}
              </div>
            </div>

            <div
              style={{
                ...this.styles.sectionForSalesTeam,
                height:
                  dashboardData2?.salesInfo.length != 0 ? "564px" : "auto",
                marginTop: "1%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "row",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    flexDirection: "row",
                    width: "50%",
                  }}
                >
                  <h2
                    style={{
                      ...this.styles.sectionTitle,
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      gap: 10,
                    }}
                  >
                    Claim Analysis
                    <div
                      style={{
                        ...this.tableStyles.searchContainer,
                      }}
                    >
                      <input
                        type="text"
                        placeholder="Search by Sales Team Name..."
                        value={claimAnalysisSearch}
                        onChange={(e) =>
                          this.setState({
                            claimAnalysisSearch: e.target.value,
                          })
                        }
                        style={this.tableStyles.searchInput}
                        onFocus={(e) =>
                          Object.assign(
                            e.target.style,
                            this.tableStyles.searchInputFocus
                          )
                        }
                        onBlur={(e) =>
                          Object.assign(e.target.style, {
                            borderColor: "#E5F1F9",
                            boxShadow: "none",
                          })
                        }
                      />
                    </div>
                  </h2>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    flexDirection: "row",
                    width: "50%",
                  }}
                >
                  <div
                    style={{
                      ...this.tableStyles.searchContainer,
                      gap: "8px",
                      maxWidth: "400px",
                    }}
                  >
                    <input
                      type="date"
                      value={claimFromDate}
                      onChange={(e) =>
                        this.setState({ claimFromDate: e.target.value })
                      }
                      style={this.tableStyles.searchInput}
                      onFocus={(e) =>
                        Object.assign(
                          e.target.style,
                          this.tableStyles.searchInputFocus
                        )
                      }
                      onBlur={(e) =>
                        Object.assign(e.target.style, {
                          borderColor: "#E5F1F9",
                          boxShadow: "none",
                        })
                      }
                      defaultValue={dayjs().format("YYYY-MM-DD")}
                      max={dayjs().format("YYYY-MM-DD")}
                    />
                    <input
                      type="date"
                      value={claimToDate}
                      onChange={(e) =>
                        this.setState({ claimToDate: e.target.value })
                      }
                      style={this.tableStyles.searchInput}
                      onFocus={(e) =>
                        Object.assign(
                          e.target.style,
                          this.tableStyles.searchInputFocus
                        )
                      }
                      onBlur={(e) =>
                        Object.assign(e.target.style, {
                          borderColor: "#E5F1F9",
                          boxShadow: "none",
                        })
                      }
                      defaultValue={dayjs().format("YYYY-MM-DD")}
                      min={claimFromDate}
                    />
                    <button
                      style={{
                        padding: "7px 16px",
                        borderRadius: "6px",
                        border: "none",
                        background: "#2563eb",
                        color: "#fff",
                        fontWeight: 500,
                        cursor: "pointer",
                      }}
                      onClick={this.searchClaimAnalysisData}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  overflow: "auto",
                }}
              >
                <div style={this.tableStyles.tableWrapper}>
                  <table style={this.tableStyles.table}>
                    <thead style={this.tableStyles.stickyHeader}>
                      <tr style={this.tableStyles.headerRow}>
                        <th style={this.tableStyles.headerCell}>Sr.No</th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "left",
                          }}
                        >
                          Sales Team Name
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "left",
                          }}
                        >
                          Type
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "center",
                          }}
                        >
                          Claim Date
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "left",
                          }}
                        >
                          Claim Type
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "right",
                          }}
                        >
                          Claim Amount
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                          }}
                        >
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredClaimAnalysisData?.map((row, index) => (
                        <tr
                          key={index + 1}
                          style={{
                            ...this.tableStyles.dataRow,
                            ...(index % 2 === 0
                              ? this.tableStyles.alternateRow
                              : {}),
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.backgroundColor =
                              this.tableStyles.dataRowHover.backgroundColor)
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.backgroundColor =
                              index % 2 === 0
                                ? this.tableStyles.alternateRow.backgroundColor
                                : this.tableStyles.dataRow.backgroundColor)
                          }
                        >
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "center",
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              color: "#004969",
                            }}
                          >
                            {row.name}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "left",
                            }}
                          >
                            {row.salesTeamTypeName}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "center",
                            }}
                          >
                            {row.date}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "left",
                            }}
                          >
                            {row.claimTypeName}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "right",
                            }}
                          >
                            ₹{row.claimAmt}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "center",
                            }}
                          >
                            <span
                              style={{
                                ...(row.flag == 0 &&
                                  this.tableStyles.statusPending),
                                ...(row.flag == 1 &&
                                  this.tableStyles.statusCancelled),
                                ...(row.flag == 2 &&
                                  this.tableStyles.statusApproved),
                                ...(row.flag == 3 &&
                                  this.tableStyles.statusRejected),
                              }}
                            >
                              {row.status}
                            </span>
                          </td>
                        </tr>
                      ))}
                      {filteredClaimAnalysisData?.length === 0 && (
                        <tr>
                          <td colSpan="6" style={this.tableStyles.noData}>
                            No matching teams found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div
              style={{
                ...this.styles.sectionForSalesTeam,
                height:
                  dashboardData2?.salesInfo.length != 0 ? "564px" : "auto",
                marginTop: "1%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "row",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    flexDirection: "row",
                    width: "50%",
                  }}
                >
                  <h2
                    style={{
                      ...this.styles.sectionTitle,
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      gap: 10,
                    }}
                  >
                    Leave Analysis
                    <div
                      style={{
                        ...this.tableStyles.searchContainer,
                      }}
                    >
                      <input
                        type="text"
                        placeholder="Search by Sales Team Name..."
                        value={leaveAnalysisSearch}
                        onChange={(e) =>
                          this.setState({
                            leaveAnalysisSearch: e.target.value,
                          })
                        }
                        style={this.tableStyles.searchInput}
                        onFocus={(e) =>
                          Object.assign(
                            e.target.style,
                            this.tableStyles.searchInputFocus
                          )
                        }
                        onBlur={(e) =>
                          Object.assign(e.target.style, {
                            borderColor: "#E5F1F9",
                            boxShadow: "none",
                          })
                        }
                      />
                    </div>
                  </h2>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    flexDirection: "row",
                    width: "50%",
                  }}
                >
                  <div
                    style={{
                      ...this.tableStyles.searchContainer,
                      gap: "8px",
                      maxWidth: "400px",
                    }}
                  >
                    <input
                      type="date"
                      value={leaveFromDate}
                      onChange={(e) =>
                        this.setState({ leaveFromDate: e.target.value })
                      }
                      style={this.tableStyles.searchInput}
                      onFocus={(e) =>
                        Object.assign(
                          e.target.style,
                          this.tableStyles.searchInputFocus
                        )
                      }
                      onBlur={(e) =>
                        Object.assign(e.target.style, {
                          borderColor: "#E5F1F9",
                          boxShadow: "none",
                        })
                      }
                      defaultValue={dayjs().format("YYYY-MM-DD")}
                      max={dayjs().format("YYYY-MM-DD")}
                    />
                    <input
                      type="date"
                      value={leaveToDate}
                      onChange={(e) =>
                        this.setState({ leaveToDate: e.target.value })
                      }
                      style={this.tableStyles.searchInput}
                      onFocus={(e) =>
                        Object.assign(
                          e.target.style,
                          this.tableStyles.searchInputFocus
                        )
                      }
                      onBlur={(e) =>
                        Object.assign(e.target.style, {
                          borderColor: "#E5F1F9",
                          boxShadow: "none",
                        })
                      }
                      defaultValue={dayjs().format("YYYY-MM-DD")}
                      min={leaveFromDate}
                    />
                    <button
                      style={{
                        padding: "7px 16px",
                        borderRadius: "6px",
                        border: "none",
                        background: "#2563eb",
                        color: "#fff",
                        fontWeight: 500,
                        cursor: "pointer",
                      }}
                      onClick={this.searchLeaveAnalysisData}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  overflow: "auto",
                }}
              >
                <div style={this.tableStyles.tableWrapper}>
                  <table style={this.tableStyles.table}>
                    <thead style={this.tableStyles.stickyHeader}>
                      <tr style={this.tableStyles.headerRow}>
                        <th style={this.tableStyles.headerCell}>Sr.No</th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "left",
                          }}
                        >
                          Sales Team Name
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "left",
                          }}
                        >
                          Type
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "center",
                          }}
                        >
                          Start Date
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "center",
                          }}
                        >
                          End Date
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "right",
                          }}
                        >
                          No. of Days
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                            textAlign: "left",
                          }}
                        >
                          Leave Type
                        </th>
                        <th
                          style={{
                            ...this.tableStyles.headerCell,
                          }}
                        >
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredLeaveAnalysisData?.map((row, index) => (
                        <tr
                          key={index + 1}
                          style={{
                            ...this.tableStyles.dataRow,
                            ...(index % 2 === 0
                              ? this.tableStyles.alternateRow
                              : {}),
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.backgroundColor =
                              this.tableStyles.dataRowHover.backgroundColor)
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.backgroundColor =
                              index % 2 === 0
                                ? this.tableStyles.alternateRow.backgroundColor
                                : this.tableStyles.dataRow.backgroundColor)
                          }
                        >
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "center",
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              color: "#004969",
                            }}
                          >
                            {row.name}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "left",
                            }}
                          >
                            {row.salesTeamTypeName}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "center",
                            }}
                          >
                            {row.startDate}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "center",
                            }}
                          >
                            {row.endDate}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "right",
                            }}
                          >
                            {row.noOfDays}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "left",
                            }}
                          >
                            {row.leaveTypeName}
                          </td>
                          <td
                            style={{
                              ...this.tableStyles.dataCell,
                              textAlign: "center",
                            }}
                          >
                            <span
                              style={{
                                ...(row.flag == 0 &&
                                  this.tableStyles.statusPending),
                                ...(row.flag == 1 &&
                                  this.tableStyles.statusCancelled),
                                ...(row.flag == 2 &&
                                  this.tableStyles.statusApproved),
                                ...(row.flag == 3 &&
                                  this.tableStyles.statusRejected),
                              }}
                            >
                              {row.status}
                            </span>
                          </td>
                        </tr>
                      ))}
                      {filteredLeaveAnalysisData?.length === 0 && (
                        <tr>
                          <td colSpan="8" style={this.tableStyles.noData}>
                            No matching teams found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                margin: "2%",
                width: "100%",
              }}
            >
              <button
                style={{
                  padding: "7px 16px",
                  borderRadius: "6px",
                  border: "none",
                  background: "#2563eb",
                  color: "#fff",
                  fontWeight: 500,
                  cursor: "pointer",
                }}
                onClick={this.onClickShowInsights}
              >
                Insights
              </button>
            </div>
          </>
        )}

        {this.state.tooltip.visible && (
          <div
            style={{
              position: "absolute",
              left: this.state.tooltip.x,
              top: this.state.tooltip.y,
              background: "#333333",
              color: "#fff",
              padding: "6px 12px",
              borderRadius: "6px",
              fontSize: "13px",
              pointerEvents: "auto",
              zIndex: 9999,
              transform: "translate(-50%, -100%)",
              width: "220px",
              maxHeight: "150px",
              overflow: "auto",
              whiteSpace: "pre-line",
            }}
            onMouseEnter={() => clearTimeout(this.tooltipTimeout)}
            onMouseLeave={this.hideTooltipWithDelay}
          >
            {this.state.tooltip.text}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  managerDashboardData: state.managerDashboard,
  dashboardData2: state.adminDashboard,
  beatList: state.beat,
});

const mapDispatchToProps = {
  getManagerDashboardApi,
  getSalesTeamInfoByDatesWithAttendance,
  getBeatFromSalesTeamId,
  showLoador,
  showNotification,
  getDashboardClaimData,
  getLeaveAnalysisDataBySalesTeam,
  getTargetAnalysisData,
  getTargetAnalysisGraphData,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(ManagerDashboard);
